// import {
//   Alert,
//   Animated,
//   BackHandler,
//   DeviceEventEmitter,
//   Dimensions,
//   Image,
//   ImageBackground,
//   NativeEventSubscription,
//   PermissionsAndroid,
//   Platform,
//   StyleSheet,
//   Text,
//   TouchableOpacity,
//   TouchableWithoutFeedback,
//   View,
// } from "react-native";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { AppIcons } from "../../assets/images";
// import { AppTheme } from "../../utils/theme";
// import { useNavigation, useRoute } from "@react-navigation/native";
// import { NativeStackNavigationProp } from "@react-navigation/native-stack";
// import FastImage from "react-native-fast-image";
// import DeviceInfo from "react-native-device-info";
// import Spacer from "../../components/global/Spacer";
// import {
//   checkPlayerWin,
//   endTurn,
//   initGame,
//   LudoState,
//   moveTokenSteps,
//   PlayerColor,
//   rollDice,
//   setCanRoll,
//   setCurrentPlayerIndex,
//   setDice,
//   Token,
// } from "../../redux/ludoSlice";
// import {
//   BlueColorPath,
//   Coordinate,
//   GreenColorPath,
//   RedColorPath,
//   YellowColorPath,
// } from "../../utils/ludoPaths";
// import { useAppSelector } from "../../redux/storeHook";
// import LottieView from "lottie-react-native";
// import {
//   AdEventType,
//   BannerAd,
//   BannerAdSize,
//   useForeground,
// } from "react-native-google-mobile-ads";
// import { useDispatch, useSelector, useStore } from "react-redux";
// import socketService from "../../services/socketService";
// import webRTCService from "../../services/webRTCService";
// import SoundPlayer from "react-native-sound-player";
// import { ROUTE_NAME } from "../../utils/routes";
// import { bannerAdKey, interstitial } from "../../utils/contants";
// import GameOverModal from "../../components/GameOverModal";
// import VoiceComponent from "../../components/VoiceComponent";
// import {
//   activateKeepAwake,
//   deactivateKeepAwake,
// } from "@sayem314/react-native-keep-awake";
// import { userAction } from "../../redux/reducers/user";

// import { NativeModules, NativeEventEmitter } from "react-native";

// const { BluetoothAudio } = NativeModules;
// const eventEmitter = new NativeEventEmitter(BluetoothAudio);

// // Start automatic management when call begins
// const startAudioManagement = () => {
//   BluetoothAudio.startListening();
//   console.log("Audio management started - auto-routing to BT or speaker");
// };

// // Stop when call ends
// const stopAudioManagement = () => {
//   BluetoothAudio.stopListening();
// };

// // Optional: Listen for changes (e.g., UI updates)
// // useEffect(() => {
// //   const subscription = eventEmitter.addListener('BluetoothAudioChanged', (isConnected: boolean) => {
// //     console.log(`BT changed: ${isConnected ? 'Routed to Bluetooth' : 'Routed to Speaker'}`);
// //     // Update UI, e.g., show BT icon
// //   });

// //   return () => subscription.remove();
// // }, []);

// const { width } = Dimensions.get("window");
// const BOARD_SIZE = width * 0.95; // Board takes 95% of screen width
// const GRID_SIZE = 15; // 15x15 grid for Ludo board
// const CELL_SIZE = BOARD_SIZE / GRID_SIZE; // Size of each cell
// const HOME_FINISH_OFFSET = CELL_SIZE * 0.2;
// const isTablet = DeviceInfo.isTablet();

// // Piece images for each color
// const PISES_IMAGES = {
//   red: AppIcons.RedToken,
//   blue: AppIcons.BlueToken,
//   green: AppIcons.GreenToken,
//   yellow: AppIcons.YellowToken,
// };

// // Path definitions for each player's tokens
// const PATHS: Record<PlayerColor, Coordinate[]> = {
//   red: RedColorPath,
//   blue: BlueColorPath,
//   green: GreenColorPath,
//   yellow: YellowColorPath,
// };

// const TOKEN_SIZE = CELL_SIZE * 0.8;
// const TOKEN_OFFSET = (CELL_SIZE - TOKEN_SIZE) / 2;
// const STACK_OFFSET = CELL_SIZE * 0.15;

// // Home turn coordinates
// const HOME_TURN_COORDS: Record<PlayerColor, Coordinate> = {
//   red: [7, 0],
//   blue: [0, 7],
//   yellow: [7, 14],
//   green: [14, 7],
// };

// interface PixelPosition {
//   x: number;
//   y: number;
// }

// const cellToPixel = (row: number, col: number): PixelPosition => ({
//   x: col * CELL_SIZE,
//   y: row * CELL_SIZE,
// });

// const tokenAreaTopLeft: Record<PlayerColor, PixelPosition> = {
//   red: { x: 0, y: 0 },
//   blue: { x: BOARD_SIZE - CELL_SIZE * 6, y: 0 },
//   green: { x: 0, y: BOARD_SIZE - CELL_SIZE * 6 },
//   yellow: { x: BOARD_SIZE - CELL_SIZE * 6, y: BOARD_SIZE - CELL_SIZE * 6 },
// };

// const homePixelFor = (color: PlayerColor, tokenId: number): PixelPosition => {
//   const areaSize = CELL_SIZE * 6;
//   const area = tokenAreaTopLeft[color];
//   const padding = (areaSize - 3 * TOKEN_SIZE) / 3;
//   const col = tokenId % 2;
//   const row = tokenId < 2 ? 0 : 1;
//   const x = area.x + padding + col * (TOKEN_SIZE + padding);
//   const y = area.y + padding + row * (TOKEN_SIZE + padding);
//   // return { x: x - 2, y: y - 2 };
//   return {
//     x: isTablet
//       ? tokenId == 0 || tokenId == 2
//         ? x + 20
//         : x + 10
//       : tokenId == 0 || tokenId == 2
//       ? x + 10
//       : x + 5,
//     y: tokenId == 2 || tokenId == 3 ? y + 3 : y + 8,
//   };
// };

// const getFinishedOffset = (
//   tokens: Record<PlayerColor, Token[]>,
//   color: PlayerColor,
//   tokenId: number
// ): { offX: number; offY: number } => {
//   const finishedTokens = (tokens[color] || [])
//     .filter((t) => t.status === "finished")
//     .sort((a, b) => a.id - b.id);

//   const numFinished = finishedTokens.length;

//   const tokenIndex = finishedTokens.findIndex((t) => t.id === tokenId);

//   if (tokenIndex === -1 || numFinished === 0) {
//     return { offX: 0, offY: 0 };
//   }

//   const pOff = HOME_FINISH_OFFSET;

//   let offX = 0;

//   let offY = 0;

//   switch (numFinished) {
//     case 2:
//       offX = tokenIndex === 0 ? -pOff : pOff;

//       offY = 0;

//       break;

//     case 3:
//       if (tokenIndex === 0) {
//         offX = -pOff;

//         offY = pOff * 0.5;
//       } else if (tokenIndex === 1) {
//         offX = pOff;

//         offY = pOff * 0.5;
//       } else {
//         offX = 0;

//         offY = -pOff * 1.5;
//       }

//       break;

//     case 4:
//       if (tokenIndex === 0) {
//         offX = -pOff;

//         offY = pOff;
//       } else if (tokenIndex === 1) {
//         offX = pOff;

//         offY = pOff;
//       } else if (tokenIndex === 2) {
//         offX = -pOff;

//         offY = -pOff;
//       } else {
//         offX = pOff;

//         offY = -pOff;
//       }

//       break;
//   }

//   return { offX, offY };
// };

// interface TokenWithColor {
//   color: PlayerColor;
//   token: Token;
// }

// interface AppState {
//   ludo: LudoState;
// }

// const getActivePlayers = (num: number): PlayerColor[] => {
//   switch (num) {
//     case 2:
//       return ["red", "yellow"];
//     case 3:
//       return ["red", "blue", "yellow"];
//     case 4:
//       return ["red", "blue", "yellow", "green"];
//     default:
//       return ["red", "blue", "yellow", "green"];
//   }
// };

// const OnlinePlay = () => {
//   const route: any = useRoute();
//   const { userData } = useAppSelector((s) => s.user);
//   const navigation = useNavigation<NativeStackNavigationProp<any>>();
//   const isOnline = !!route?.params?.roomId;
//   const onlineParams = isOnline ? route.params : {};
//   const {
//     roomId,
//     playerName,
//     myColor: onlineMyColor,
//     players: connectedPlayersInit,
//     numPlayers: onlineNumPlayers,
//   } = onlineParams;
//   console.log("@ online params : ", onlineParams);
//   // Local mode state
//   const [numPlayers, setNumPlayers] = useState<number | null>(
//     isOnline ? onlineNumPlayers : null
//   );
//   // Online-specific state
//   const [chatMessages, setChatMessages] = useState([]);
//   const [isChatVisible, setIsChatVisible] = useState(false);
//   const [isMuted, setIsMuted] = useState(true);
//   const [playerMuteStates, setPlayerMuteStates] = useState({});
//   const [connectedPlayers, setConnectedPlayers] = useState(
//     connectedPlayersInit || []
//   );
//   const [isMyTurn, setIsMyTurn] = useState(false);
//   const [autoEnding, setAutoEnding] = useState(false);
//   const [remoteStreams, setRemoteStreams] = useState(new Map());
//   // Shared game state
//   const [gameOver, setGameOver] = useState(false);
//   const [displayWinners, setDisplayWinners] = useState<PlayerColor[]>([]);
//   const [isAnimatingDice, setIsAnimatingDice] = useState(false);
//   const [canTap, setCanTap] = useState(true);
//   const [firstWinner, setFirstWinner] = useState<PlayerColor | null>(null);

//   const { isSoundOn } = useAppSelector((state) => state.user);
//   const lottieRef = useRef<LottieView>(null);
//   const bannerRef = useRef<BannerAd>(null);
//   const dispatch = useDispatch();
//   const store = useStore();
//   const state = useSelector((s: AppState) => s.ludo);
//   let boomSub: NativeEventSubscription | null = null;
//   let diceSub: NativeEventSubscription | null = null;
//   let pieceSub: NativeEventSubscription | null = null;
//   let pieceCutSub: NativeEventSubscription | null = null;
//   let isLooping: boolean = false;
//   let isDiceLooping: boolean = false;
//   let isPieceLooping: boolean = false;
//   let isPieceCutLooping: boolean = false;
//   const {
//     tokens,
//     paths,
//     currentPlayerIndex,
//     dice,
//     winners,
//     canRoll,
//     capturedToken,
//     tokenReachedHome,
//     consecutiveSixes,
//     isReturnInProgress,
//   } = state;
//   // Determine activePlayers
//   const activePlayers = useMemo(() => {
//     if (isOnline) {
//       return connectedPlayers.map((p: any) => p.color);
//     }
//     return numPlayers ? getActivePlayers(numPlayers) : [];
//   }, [isOnline, connectedPlayers, numPlayers]);
//   const playingPlayers = useMemo(
//     () => activePlayers.filter((p: any) => !winners.includes(p)),
//     [activePlayers, winners]
//   );
//   const effectiveCurrentIndex = currentPlayerIndex % activePlayers.length;
//   const currentColor = activePlayers[effectiveCurrentIndex] || "red";
//   const myColor = isOnline ? onlineMyColor : currentColor;
//   // Check if it's my turn (online only)

//   const allFinishedByColor = useMemo(() => {
//     //@ts-ignore
//     const finished: Record<PlayerColor, boolean> = {};
//     //@ts-ignore
//     activePlayers.forEach((color) => {
//       //@ts-ignore
//       finished[color] = (tokens[color] || []).every(
//         //@ts-ignore
//         (t) => t.status === "finished"
//       );
//     });
//     return finished;
//   }, [tokens, activePlayers]);
//   useEffect(() => {
//     if (isOnline) {
//       setIsMyTurn(currentColor === myColor && !gameOver);
//     }
//   }, [currentColor, myColor, gameOver, isOnline]);

//   const anims = useRef<Record<PlayerColor, Record<number, Animated.ValueXY>>>({
//     red: {},
//     blue: {},
//     green: {},
//     yellow: {},
//   }).current;

//   useEffect(() => {
//     DeviceEventEmitter.addListener("Proximity", function (data) {
//       // --- do something with events
//       console.log("@ Proximity : ", data);
//     });
//   }, []);

//   useEffect(() => {
//     userAction.setTouchSound(true); // Trigger touch sound on start
//     userAction.setMusicPreference(false); // Stop music for game
//   }, []);

//   // color names
//   const redColorUser = useCallback(() => {
//     const findUser = connectedPlayersInit?.find((e: any) => e?.color == "red");
//     if (findUser) {
//       return { name: findUser?.name, image: findUser?.profilePhoto };
//     }
//     return { name: "", image: "" };
//   }, [connectedPlayersInit]);

//   const blueColorUser = useCallback(() => {
//     const findUser = connectedPlayersInit?.find((e: any) => e?.color == "blue");
//     if (findUser) {
//       return { name: findUser?.name, image: findUser?.profilePhoto };
//     }
//     return { name: "", image: "" };
//   }, [connectedPlayersInit]);

//   const yellowColorUser = useCallback(() => {
//     const findUser = connectedPlayersInit?.find(
//       (e: any) => e?.color == "yellow"
//     );
//     if (findUser) {
//       return { name: findUser?.name, image: findUser?.profilePhoto };
//     }
//     return { name: "", image: "" };
//   }, [connectedPlayersInit]);

//   const greenColorUser = useCallback(() => {
//     const findUser = connectedPlayersInit?.find(
//       (e: any) => e?.color == "green"
//     );
//     if (findUser) {
//       return { name: findUser?.name, image: findUser?.profilePhoto };
//     }
//     return { name: "", image: "" };
//   }, [connectedPlayersInit]);
//   // Game over logic
//   useEffect(() => {
//     let finalWinners: PlayerColor[] = winners.filter((w) =>
//       activePlayers.includes(w)
//     );
//     if (winners.length > 0 && firstWinner === null) {
//       setFirstWinner(winners[0]);
//     }
//     if (playingPlayers.length === 1) {
//       finalWinners = [...finalWinners, playingPlayers[0]];
//       setGameOver(true);
//     } else if (playingPlayers.length === 0) {
//       setGameOver(true);
//     }
//     setDisplayWinners(finalWinners);
//   }, [winners, activePlayers, playingPlayers]);

//   // Optional: Listen for changes (e.g., UI updates)
//   useEffect(() => {
//     const subscription = eventEmitter.addListener(
//       "BluetoothAudioChanged",
//       (isConnected: boolean) => {
//         console.log(
//           `BT changed: ${
//             isConnected ? "Routed to Bluetooth" : "Routed to Speaker"
//           }`
//         );
//         userAction.setMusicPreference(false);
//         userAction.setTouchSound(true);
//         userAction.setPlayGame(true);
//         // Update UI, e.g., show BT icon
//       }
//     );

//     return () => subscription.remove();
//   }, []);
//   // Auto end turn if no legal moves (shared, but conditional)
//   useEffect(() => {
//     const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
//     const playerColor = isOnline ? myColor : currentColor;
//     if (
//       isTurn &&
//       dice !== null &&
//       !isAnimatingDice &&
//       !autoEnding &&
//       !gameOver
//     ) {
//       const legal = getLegalMoves(playerColor, dice);
//       if (legal.length === 0) {
//         setAutoEnding(true);
//         dispatch(setDice(null));
//         setTimeout(() => {
//           endActiveTurn();
//           setAutoEnding(false);
//         }, 1500);
//       }
//     }
//   }, [
//     dice,
//     currentPlayerIndex,
//     isMyTurn,
//     isAnimatingDice,
//     autoEnding,
//     myColor,
//     currentColor,
//     gameOver,
//   ]);
//   // Auto-move if only one legal move (shared, conditional)
//   useEffect(() => {
//     const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
//     const playerColor = isOnline ? myColor : currentColor;
//     if (!isTurn || dice == null || gameOver || autoEnding) return;
//     const legal = getLegalMoves(playerColor, dice);
//     if (dice === 6 && consecutiveSixes >= 3) {
//       setTimeout(() => {
//         dispatch(setDice(null));
//         endActiveTurn();
//       }, 400);
//       return;
//     }
//     if (legal.length === 0) return; // Handled in previous effect
//     if (legal.length === 1) {
//       const only = legal[0];
//       const moveSteps = only.action === "bringOut" ? "bringOut" : dice;
//       if (!isOnline && isSoundOn) playPieceLoop();
//       if (isOnline) {
//         socketService.emitTokenMove(roomId, {
//           color: playerColor,
//           tokenId: only.tokenId,
//           steps: moveSteps,
//         });
//       }
//       dispatch(
//         moveTokenSteps({
//           color: playerColor,
//           tokenId: only.tokenId,
//           steps: moveSteps,
//         }) as any
//       ).then(() => {
//         if (!isOnline && isSoundOn) {
//           setTimeout(() => {
//             stopPieceLoop();
//           }, 240);
//         }
//         //@ts-ignore
//         const stateAfterMove = store.getState().ludo;
//         const wasCaptured = stateAfterMove.capturedToken;
//         dispatch(checkPlayerWin({ color: playerColor }));
//         //@ts-ignore
//         const stateAfterCheck = store.getState().ludo;
//         const reachedHome = stateAfterCheck.tokenReachedHome;
//         const updatedWinners = stateAfterCheck.winners;
//         const updatedPlayingPlayers = activePlayers.filter(
//           (p: any) => !updatedWinners.includes(p)
//         );
//         dispatch(setDice(null));
//         if (updatedPlayingPlayers.length === 0) {
//           setGameOver(true);
//           return;
//         }
//         if (updatedWinners.includes(playerColor)) {
//           endActiveTurn();
//         } else {
//           if (wasCaptured || reachedHome || dice === 6) {
//             dispatch(setCanRoll(true));
//           } else {
//             endActiveTurn();
//           }
//         }
//       });
//     }
//   }, [
//     dice,
//     currentPlayerIndex,
//     isMyTurn,
//     gameOver,
//     autoEnding,
//     myColor,
//     currentColor,
//     consecutiveSixes,
//     isOnline,
//     roomId,
//     store,
//     activePlayers,
//     playingPlayers,
//   ]);
//   // Online initialization
//   useEffect(() => {
//     if (isOnline) {
//       initializeOnlineFeatures();
//       setupSocketListeners();
//       setupWebRTC();
//       // return () => {
//       //   cleanup();
//       // };
//     }
//   }, [isOnline]);
//   const initializeOnlineFeatures = () => {
//     dispatch(initGame(activePlayers));
//   };
//   const setupSocketListeners = () => {
//     //@ts-ignore
//     socketService.onOpponentDiceRolled(({ diceValue, playerId }) => {
//       console.log(`Opponent rolled: ${diceValue}`);
//       dispatch(setDice(diceValue));
//       dispatch(setCanRoll(false));
//     });
//     //@ts-ignore
//     socketService.onOpponentTokenMoved(({ moveData }) => {
//       const { color, tokenId, steps } = moveData;
//       dispatch(moveTokenSteps({ color, tokenId, steps }) as any)
//         .then(() => {
//           dispatch(checkPlayerWin({ color }));
//         })
//         .catch((error: any) => {
//           console.error("Error handling opponent move:", error);
//         });
//     });
//     socketService.onAdvanceTurn?.(() => {
//       dispatch(endTurn());
//     });
//     //@ts-ignore
//     socketService.onGameOver(({ winner, reason }) => {
//       setDisplayWinners([winner.color]);
//       setGameOver(true);
//     });
//     // @ts-ignore
//     socketService.onGameStateUpdated(({ gameState }) => {
//       console.log("Game state updated from server");
//     });
//     socketService.onNewMessage((message: any) => {
//       //@ts-ignore
//       setChatMessages((prev) => [...prev, message]);
//     });
//     //@ts-ignore
//     socketService.onPlayerLeft(({ playerId, room }) => {
//       const disconnectedPlayer = connectedPlayers.find(
//         (p: any) => p.id === playerId
//       );
//       if (disconnectedPlayer) {
//         console.log("@ disconnect");
//       }
//       if (room && room.players) {
//         setConnectedPlayers(room.players);
//       }
//     });
//     //@ts-ignore
//     socketService.onPlayerMuteChanged(({ playerId, isMuted }) => {
//       setPlayerMuteStates((prev) => ({
//         ...prev,
//         [playerId]: isMuted,
//       }));
//     });
//   };
//   const setupWebRTC = async () => {
//     try {
//       if (Platform.OS === "android") {
//         const granted = await PermissionsAndroid.request(
//           PermissionsAndroid.PERMISSIONS.RECORD_AUDIO,
//           {
//             title: "Microphone Permission",
//             message: "This app needs microphone access for voice chat.",
//             buttonNeutral: "Ask Me Later",
//             buttonNegative: "Cancel",
//             buttonPositive: "OK",
//           }
//         );
//         if (granted !== PermissionsAndroid.RESULTS.GRANTED) {
//           throw new Error("Microphone permission denied");
//         }
//       }
//       // InCallManager.start({ media: "audio" });
//       // InCallManager.setForceSpeakerphoneOn(true);
//       // InCallManager.setSpeakerphoneOn(true);
//       // console.log("Loudspeaker automatically enabled");
//       // IncallManagerLight.disableProximity()
//       await webRTCService.getLocalStream();
//       setTimeout(() => {
//         startAudioManagement();
//       }, 3000);
//       //@ts-ignore
//       webRTCService.setOnIceCandidate((peerId, candidate) => {
//         socketService.sendICECandidate(roomId, candidate, peerId);
//       });
//       //@ts-ignore
//       const handleRemoteStream = (peerId, remoteStream) => {
//         console.log(`Stream callback: Playing audio from ${peerId}`);
//         setRemoteStreams((prev) => new Map(prev).set(peerId, remoteStream));
//       };
//       webRTCService.setOnRemoteStreamAdded(handleRemoteStream);
//       //@ts-ignore
//       socketService.onWebRTCOffer(async ({ offer, senderId }) => {
//         const answer = await webRTCService.handleOffer(
//           senderId,
//           offer,
//           handleRemoteStream
//         );
//         if (answer) {
//           socketService.sendWebRTCAnswer(roomId, answer, senderId);
//         }
//       });
//       //@ts-ignore
//       socketService.onWebRTCAnswer(async ({ answer, senderId }) => {
//         await webRTCService.handleAnswer(senderId, answer);
//       });
//       //@ts-ignore
//       socketService.onICECandidate(async ({ candidate, senderId }) => {
//         await webRTCService.handleICECandidate(senderId, candidate);
//       });
//       for (const player of connectedPlayers) {
//         if (player.color !== myColor) {
//           const pc = webRTCService.createPeerConnection(
//             player.id,
//             handleRemoteStream
//           );
//           //@ts-ignore
//           const isHost = connectedPlayers[0].id === socketService?.socket?.id;
//           if (isHost) {
//             const offer = await webRTCService.createOffer(player.id);
//             if (offer) {
//               socketService.sendWebRTCOffer(roomId, offer, player.id);
//             }
//           }
//         }
//       }
//     } catch (error: any) {
//       console.error("WebRTC setup failed:", error);
//       Alert.alert(
//         "Voice Chat",
//         `Voice chat could not be initialized: ${error.message}`
//       );
//     }
//   };
//   const cleanup = () => {
//     if (isOnline) {
//       webRTCService.cleanup();
//       socketService.removeAllListeners();
//       stopAudioManagement();
//       // InCallManager.stop();
//       // InCallManager.setForceSpeakerphoneOn(false);
//       // InCallManager.setSpeakerphoneOn(false);
//       setRemoteStreams(new Map());
//     }
//   };
//   // Shared endActiveTurn
//   const endActiveTurn = useCallback(() => {
//     if (!activePlayers.length) return;
//     let currentEffective = currentPlayerIndex % activePlayers.length;
//     let nextEffective = (currentEffective + 1) % activePlayers.length;
//     while (winners.includes(activePlayers[nextEffective])) {
//       nextEffective = (nextEffective + 1) % activePlayers.length;
//       if (nextEffective === currentEffective) {
//         setGameOver(true);
//         return;
//       }
//     }
//     dispatch(endTurn());
//     dispatch(setCurrentPlayerIndex(nextEffective));
//     if (isOnline) {
//       socketService.advanceTurn(roomId);
//     }
//   }, [
//     dispatch,
//     currentPlayerIndex,
//     activePlayers,
//     winners,
//     setGameOver,
//     isOnline,
//     roomId,
//   ]);
//   // Dice roll handler (sets animation, dispatch in useEffect)
//   const onRoll = useCallback(() => {
//     const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
//     if (!isTurn || gameOver || isAnimatingDice) return;
//     setIsAnimatingDice(true);
//   }, [
//     isMyTurn,
//     gameOver,
//     isAnimatingDice,
//     playingPlayers,
//     currentColor,
//     isOnline,
//   ]);
//   // Dice animation useEffect (shared)
//   useEffect(() => {
//     if (isAnimatingDice) {
//       if (!isOnline && isSoundOn) {
//         const playDiceLoop = () => {
//           if (isDiceLooping) return;
//           isDiceLooping = true;
//           diceSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
//             if (isDiceLooping && isSoundOn) {
//               try {
//                 SoundPlayer.playSoundFile("dise", "mp3");
//               } catch (error) {}
//             }
//           });
//           try {
//             SoundPlayer.playSoundFile("dise", "mp3");
//           } catch (error) {}
//         };
//         playDiceLoop();
//         const stopDiceLoop = () => {
//           isDiceLooping = false;
//           if (diceSub) {
//             diceSub.remove();
//             diceSub = null;
//           }
//           try {
//             SoundPlayer.stop();
//           } catch (error) {}
//         };
//         return () => stopDiceLoop();
//       }
//       if (lottieRef.current) {
//         lottieRef.current.play(0, -1);
//       }
//       const timer = setTimeout(async () => {
//         const result = await dispatch(rollDice() as any);
//         const diceValue = result.payload;
//         if (isOnline) {
//           socketService.emitDiceRoll(
//             roomId,
//             diceValue,
//             //@ts-ignore
//             socketService.socket.id
//           );
//         }
//         //@ts-ignore
//         const afterState = store?.getState()?.ludo;
//         if (afterState.consecutiveSixes >= 3) {
//           dispatch(setDice(null));
//           endActiveTurn();
//         }
//         setIsAnimatingDice(false);
//         if (lottieRef.current) {
//           lottieRef.current.reset();
//         }
//         if (!isOnline && isSoundOn) {
//           const stopDiceLoop = () => {
//             isDiceLooping = false;
//             if (diceSub) {
//               diceSub.remove();
//               diceSub = null;
//             }
//             try {
//               SoundPlayer.stop();
//             } catch (error) {}
//           };
//           stopDiceLoop();
//         }
//       }, 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [isAnimatingDice, dispatch, roomId, store, isOnline, isSoundOn]);
//   // Token press handler (conditional)
//   const onTokenPress = useCallback(
//     (color: PlayerColor, tokenId: number) => {
//       const isTurn = isOnline
//         ? isMyTurn
//         : playingPlayers.includes(currentColor);
//       const playerColor = isOnline ? myColor : currentColor;
//       if (!isTurn || color !== playerColor || dice == null || gameOver) return;
//       if (dice === 6 && consecutiveSixes >= 3) {
//         dispatch(setDice(null));
//         endActiveTurn();
//         return;
//       }
//       const legal = getLegalMoves(color, dice);
//       const chosen = legal.find((m) => m.tokenId === tokenId);
//       if (!chosen) {
//         if (legal.length === 0) {
//           dispatch(setDice(null));
//           endActiveTurn();
//         } else {
//           console.log("Invalid move! Try another token.");
//         }
//         return;
//       }
//       const moveSteps = chosen.action === "bringOut" ? "bringOut" : dice;
//       if (!isOnline && isSoundOn) playPieceLoop();
//       if (isOnline) {
//         socketService.emitTokenMove(roomId, {
//           color,
//           tokenId,
//           steps: moveSteps,
//         });
//       }
//       dispatch(
//         moveTokenSteps({ color, tokenId, steps: moveSteps }) as any
//       ).then(() => {
//         if (!isOnline && isSoundOn) {
//           setTimeout(() => {
//             stopPieceLoop();
//           }, 240);
//         }
//         //@ts-ignore
//         const stateAfterMove = store?.getState()?.ludo;
//         const wasCaptured = stateAfterMove.capturedToken;
//         dispatch(checkPlayerWin({ color }));
//         //@ts-ignore
//         const stateAfterCheck = store?.getState()?.ludo;
//         const reachedHome = stateAfterCheck.tokenReachedHome;
//         const updatedWinners = stateAfterCheck.winners;
//         const updatedPlayingPlayers = activePlayers.filter(
//           (p: any) => !updatedWinners.includes(p)
//         );
//         dispatch(setDice(null));
//         if (updatedPlayingPlayers.length === 0) {
//           setGameOver(true);
//           return;
//         }
//         if (updatedWinners.includes(color)) {
//           endActiveTurn();
//         } else {
//           if (wasCaptured || reachedHome || dice === 6) {
//             dispatch(setCanRoll(true));
//           } else {
//             endActiveTurn();
//           }
//         }
//       });
//     },
//     [
//       isMyTurn,
//       myColor,
//       currentColor,
//       dice,
//       consecutiveSixes,
//       gameOver,
//       dispatch,
//       roomId,
//       store,
//       activePlayers,
//       playingPlayers,
//       isOnline,
//       isSoundOn,
//       endActiveTurn,
//     ]
//   );
//   // Online chat/voice handlers
//   const handleSendMessage = (message: any) => {
//     if (!isOnline) return;
//     socketService.sendMessage(roomId, message, playerName);
//   };
//   const toggleChat = () => {
//     if (!isOnline) return;
//     setIsChatVisible(!isChatVisible);
//   };
//   const handleToggleMute = () => {
//     if (!isOnline) return;
//     const newMuteState = webRTCService.toggleMute();
//     setIsMuted(newMuteState);
//     socketService.toggleMute(roomId, newMuteState);
//   };
//   // Back/leave handlers
//   const handleLeaveGame = () => {
//     if (!isOnline) {
//       Alert.alert(
//         "Exit Game",
//         "Are you sure you want to exit the current game?",
//         [
//           { text: "Cancel", style: "cancel" },
//           {
//             text: "Exit",
//             style: "destructive",
//             onPress: () => {
//               try {
//                 SoundPlayer.stop();
//                 // userAction.setTouchSound(true);
//               } catch (error) {}
//               navigation.goBack();
//             },
//           },
//         ]
//       );
//       return;
//     }
//     Alert.alert(
//       "Leave Game",
//       "Are you sure you want to leave? This will disconnect you from the game.",
//       [
//         { text: "Cancel", style: "cancel" },
//         {
//           text: "Leave",
//           style: "destructive",
//           onPress: () => {
//             SoundPlayer.stop();
//             socketService.leaveRoom(roomId);
//             cleanup();
//             setTimeout(() => {
//               userAction.setTouchSound(true);
//               userAction.setMusicPreference(true);
//               userAction.setPlayGame(false);
//               navigation.replace(ROUTE_NAME.PlayerRoom);
//             }, 500);
//           },
//         },
//       ]
//     );
//   };
//   // Restart handler
//   const restartGame = () => {
//     socketService.leaveRoom(roomId);
//     setGameOver(false);
//     setFirstWinner(null);
//     cleanup();
//     userAction.setTouchSound(true);
//     userAction.setMusicPreference(true);
//     userAction.setPlayGame(false);
//     navigation.replace(ROUTE_NAME.PlayerRoom);
//   };
//   // Local sound effects (only if !isOnline)
//   useEffect(() => {
//     if (isReturnInProgress && !isOnline) {
//       SoundPlayer.stop();
//       setTimeout(() => {
//         playPieceCutLoop();
//       }, 500);
//     }
//     if (!isReturnInProgress && !isOnline) {
//       stopPieceCutLoop();
//       console.log("Return animation completed.");
//     }
//   }, [isReturnInProgress, isOnline]);
//   useEffect(() => {
//     if (gameOver && displayWinners.length > 0 && !isOnline) {
//       SoundPlayer.stop();
//       setTimeout(() => {
//         playLoop();
//       }, 500);
//     }
//   }, [gameOver, displayWinners, isOnline]);
//   const playLoop = () => {
//     if (isLooping || isOnline) return;
//     isLooping = true;
//     boomSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
//       if (isLooping && isSoundOn) {
//         try {
//           SoundPlayer.playSoundFile("boom", "mp3");
//         } catch (error) {}
//       }
//     });
//     try {
//       if (isSoundOn) {
//         SoundPlayer.playSoundFile("boom", "mp3");
//       }
//     } catch (error) {}
//   };
//   const stopLoop = () => {
//     isLooping = false;
//     if (boomSub) {
//       boomSub.remove();
//       boomSub = null;
//     }
//     try {
//       SoundPlayer.stop();
//     } catch (error) {}
//   };
//   const playPieceLoop = () => {
//     if (isPieceLooping || isOnline) return;
//     isPieceLooping = true;
//     pieceSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
//       if (isPieceLooping && isSoundOn) {
//         try {
//           SoundPlayer.playSoundFile("pice", "mp3");
//         } catch (error) {}
//       }
//     });
//     try {
//       if (isSoundOn) {
//         SoundPlayer.playSoundFile("pice", "mp3");
//       }
//     } catch (error) {}
//   };
//   const stopPieceLoop = () => {
//     isPieceLooping = false;
//     if (pieceSub) {
//       pieceSub.remove();
//       pieceSub = null;
//     }
//     try {
//       SoundPlayer.stop();
//     } catch (error) {}
//   };
//   const playPieceCutLoop = () => {
//     if (isPieceCutLooping || isOnline) return;
//     isPieceCutLooping = true;
//     try {
//       if (isSoundOn) {
//         SoundPlayer.playSoundFile("cutpice", "mp3");
//       }
//     } catch (error) {}
//   };
//   const stopPieceCutLoop = () => {
//     isPieceCutLooping = false;
//     if (pieceCutSub) {
//       pieceCutSub.remove();
//       pieceCutSub = null;
//     }
//     try {
//       SoundPlayer.stop();
//     } catch (error) {}
//   };
//   // Back handler (local only)
//   useEffect(() => {
//     // if (!isOnline && numPlayers) {
//     const onBackPress = () => {
//       Alert.alert(
//         "Leave Game",
//         "Are you sure you want to leave? This will disconnect you from the game.",
//         [
//           { text: "Cancel", style: "cancel" },
//           {
//             text: "Leave",
//             style: "destructive",
//             onPress: () => {
//               socketService.leaveRoom(roomId);
//               cleanup();
//               navigation.replace(ROUTE_NAME.PlayerRoom);
//             },
//           },
//         ]
//       );
//       return true;
//     };
//     const subscription = BackHandler.addEventListener(
//       "hardwareBackPress",
//       onBackPress
//     );
//     return () => subscription.remove();
//     // }
//   }, [numPlayers, isOnline, navigation]);
//   // Ads (shared)
//   useForeground(() => {
//     Platform.OS === "ios" && bannerRef.current?.load();
//   });
//   useEffect(() => {
//     const unsubscribeLoaded = interstitial.addAdEventListener(
//       AdEventType.LOADED,
//       () => {
//         console.log("@ interstitial ad loaded");
//       }
//     );
//     const unsubscribeOpened = interstitial.addAdEventListener(
//       AdEventType.OPENED,
//       () => {
//         console.log("@ interstitial ad opened");
//       }
//     );
//     const unsubscribeClosed = interstitial.addAdEventListener(
//       AdEventType.CLOSED,
//       () => {
//         console.log("@ interstitial ad closed");
//       }
//     );
//     interstitial.load();
//     return () => {
//       unsubscribeLoaded();
//       unsubscribeOpened();
//       unsubscribeClosed();
//     };
//   }, []);
//   // Initialize game (conditional)
//   useEffect(() => {
//     if (numPlayers !== null) {
//       const playersToInit = isOnline
//         ? activePlayers
//         : getActivePlayers(numPlayers);
//       dispatch(initGame(playersToInit));
//     }
//   }, [numPlayers, isOnline]);
//   // Animation initialization (shared)
//   useEffect(() => {
//     if (numPlayers === null) return;
//     //@ts-ignore
//     activePlayers.forEach((color) => {
//       //@ts-ignore
//       if (!anims[color]) anims[color] = {};
//       //@ts-ignore
//       const path = paths[color] || PATHS[color] || [];
//       //@ts-ignore
//       (tokens[color] || []).forEach((tok) => {
//         //@ts-ignore
//         if (!anims[color][tok.id]) {
//           let pos: PixelPosition = { x: 0, y: 0 };
//           if (tok.status === "onpath") {
//             const coord = path[tok.pathIndex];
//             pos = cellToPixel(coord[0], coord[1]);
//           } else {
//             if (tok.status === "home" || tok.status === "returning") {
//               pos = homePixelFor(color, tok.id);
//             } else if (tok.status === "finished") {
//               const last = path[path.length - 1];
//               let basePos = cellToPixel(last[0], last[1]);
//               const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
//               basePos.x += offX;
//               basePos.y += offY;
//               pos = basePos;
//             }
//           }
//           //@ts-ignore
//           anims[color][tok.id] = new Animated.ValueXY({
//             x: pos.x + TOKEN_OFFSET,
//             y: pos.y + TOKEN_OFFSET,
//           });
//         }
//       });
//     });
//   }, [numPlayers]);
//   // Token animation (shared)
//   useEffect(() => {
//     if (numPlayers === null) return;
//     //@ts-ignore
//     activePlayers.forEach((color) => {
//       //@ts-ignore
//       const path = paths[color] || PATHS[color] || [];
//       //@ts-ignore
//       (tokens[color] || []).forEach((tok) => {
//         //@ts-ignore
//         const a = anims[color] && anims[color][tok.id];
//         if (!a) return;
//         let dest: PixelPosition = { x: 0, y: 0 };
//         if (tok.status === "onpath") {
//           const coord = path[tok.pathIndex];
//           dest = cellToPixel(coord[0], coord[1]);
//         } else if (tok.status === "home") {
//           dest = homePixelFor(color, tok.id);
//         } else if (tok.status === "returning") {
//           if (tok.pathIndex >= 0 && tok.pathIndex < path.length) {
//             const coord = path[tok.pathIndex];
//             dest = cellToPixel(coord[0], coord[1]);
//           } else {
//             dest = homePixelFor(color, tok.id);
//           }
//         } else if (tok.status === "finished") {
//           const coord = path[path.length - 1];
//           let baseDest = cellToPixel(coord[0], coord[1]);
//           const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
//           baseDest.x += offX;
//           baseDest.y += offY;
//           dest = baseDest;
//         }
//         dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
//         Animated.timing(a, {
//           toValue: { x: dest.x, y: dest.y },
//           duration: 240,
//           useNativeDriver: true,
//         }).start();
//       });
//     });
//   }, [tokens, paths, activePlayers, numPlayers]);
//   // Stacking animation (shared)
//   useEffect(() => {
//     if (numPlayers === null) return;
//     //@ts-ignore
//     activePlayers.forEach((color) => {
//       //@ts-ignore
//       const path = paths[color] || PATHS[color] || [];
//       //@ts-ignore
//       (tokens[color] || []).forEach((tok) => {
//         //@ts-ignore
//         const a = anims[color] && anims[color][tok.id];
//         if (!a) return;
//         let dest: PixelPosition = { x: 0, y: 0 };
//         if (tok.status === "onpath" || tok.status === "returning") {
//           if (tok.pathIndex >= 0 && tok.pathIndex < path.length) {
//             dest = getStackedPosition(color, tok);
//           } else {
//             dest = homePixelFor(color, tok.id);
//             dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
//           }
//         } else if (tok.status === "home") {
//           dest = homePixelFor(color, tok.id);
//           dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
//         } else if (tok.status === "finished") {
//           const coord = path[path.length - 1];
//           let baseDest = cellToPixel(coord[0], coord[1]);
//           const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
//           baseDest.x += offX;
//           baseDest.y += offY;
//           dest = { x: baseDest.x + TOKEN_OFFSET, y: baseDest.y + TOKEN_OFFSET };
//         }
//         Animated.timing(a, {
//           toValue: { x: dest.x, y: dest.y },
//           duration: 240,
//           useNativeDriver: true,
//         }).start();
//       });
//     });
//   }, [tokens, paths, activePlayers, currentPlayerIndex, numPlayers]);
//   // Shared helper functions
//   const getLegalMoves = useCallback(
//     (color: PlayerColor, diceVal: number) => {
//       const path = paths[color] || PATHS[color] || [];
//       const myTokens = tokens[color] || [];
//       const moves: { tokenId: number; action: "bringOut" | "move" }[] = [];
//       const homeTurnCoord = HOME_TURN_COORDS[color];
//       const homeTurnIndex = path.findIndex(
//         (coord) =>
//           coord[0] === homeTurnCoord[0] && coord[1] === homeTurnCoord[1]
//       );
//       myTokens.forEach((t) => {
//         if (t.status === "home") {
//           if (diceVal === 6) moves.push({ tokenId: t.id, action: "bringOut" });
//         } else if (t.status === "onpath") {
//           const remaining = path.length - 1 - t.pathIndex;
//           const isInHomeStretch =
//             homeTurnIndex !== -1 && t.pathIndex >= homeTurnIndex;
//           if (isInHomeStretch) {
//             if (diceVal <= remaining) {
//               moves.push({ tokenId: t.id, action: "move" });
//             }
//           } else {
//             if (remaining > 0) {
//               moves.push({ tokenId: t.id, action: "move" });
//             }
//           }
//         }
//       });
//       return moves;
//     },
//     [paths, tokens]
//   );
//   const getTokensAtCell = (row: number, col: number): TokenWithColor[] => {
//     const tokensAtCell: TokenWithColor[] = [];
//     //@ts-ignore
//     activePlayers.forEach((color) => {
//       //@ts-ignore
//       const path = paths[color] || PATHS[color] || [];
//       //@ts-ignore
//       (tokens[color] || []).forEach((token) => {
//         if (token.status === "onpath" || token.status === "returning") {
//           if (token.pathIndex >= 0 && token.pathIndex < path.length) {
//             const coord = path[token.pathIndex];
//             if (coord && coord[0] === row && coord[1] === col) {
//               tokensAtCell.push({ color, token });
//             }
//           }
//         }
//       });
//     });
//     return tokensAtCell;
//   };
//   const getStackedPosition = (
//     color: PlayerColor,
//     token: Token
//   ): PixelPosition => {
//     const path = paths[color] || PATHS[color] || [];
//     if (
//       (token.status !== "onpath" && token.status !== "returning") ||
//       token.pathIndex < 0 ||
//       !path[token.pathIndex]
//     ) {
//       return { x: 0, y: 0 };
//     }
//     const coord = path[token.pathIndex];
//     const tokensAtCell = getTokensAtCell(coord[0], coord[1]);
//     tokensAtCell.sort((a, b) => {
//       if (a.color === currentColor && b.color !== currentColor) return 1;
//       if (a.color !== currentColor && b.color === currentColor) return -1;
//       if (a.color === b.color) return a.token.id - b.token.id;
//       return activePlayers.indexOf(a.color) - activePlayers.indexOf(b.color);
//     });
//     const tokenIndex = tokensAtCell.findIndex(
//       (t) => t.color === color && t.token.id === token.id
//     );
//     const basePos = cellToPixel(coord[0], coord[1]);
//     const offset = tokenIndex * STACK_OFFSET;
//     return {
//       x: basePos.x + TOKEN_OFFSET + offset,
//       y: basePos.y + TOKEN_OFFSET + offset,
//     };
//   };
//   const getTokenZIndex = (color: PlayerColor, token: Token): number => {
//     if (token.status !== "onpath" && token.status !== "returning") {
//       if (token.status === "finished") {
//         const finishedTokens = (tokens[color] || [])
//           .filter((t) => t.status === "finished")
//           .sort((a, b) => a.id - b.id);
//         const tokenIndex = finishedTokens.findIndex((t) => t.id === token.id);
//         return 10 + (tokenIndex + 1);
//       }
//       return 10;
//     }
//     const path = paths[color] || PATHS[color] || [];
//     if (token.pathIndex < 0 || !path[token.pathIndex]) return 10;
//     const coord = path[token.pathIndex];
//     const tokensAtCell = getTokensAtCell(coord[0], coord[1]);
//     tokensAtCell.sort((a, b) => {
//       if (a.color === currentColor && b.color !== currentColor) return 1;
//       if (a.color !== currentColor && b.color === currentColor) return -1;
//       if (a.color === b.color) return a.token.id - b.token.id;
//       return activePlayers.indexOf(a.color) - activePlayers.indexOf(b.color);
//     });
//     const tokenIndex = tokensAtCell.findIndex(
//       (t) => t.color === color && t.token.id === token.id
//     );
//     return 10 + tokenIndex;
//   };
//   const renderTokensPile = () => (
//     <View style={styles.tokensGrid}>
//       {[0, 1, 2, 3].map((i) => (
//         <View key={i}>
//           <View />
//         </View>
//       ))}
//     </View>
//   );
//   const getDiceImage = (num: any) => {
//     switch (num) {
//       case 1:
//         return AppIcons.Dice_1;
//       case 2:
//         return AppIcons.Dice_2;
//       case 3:
//         return AppIcons.Dice_3;
//       case 4:
//         return AppIcons.Dice_4;
//       case 5:
//         return AppIcons.Dice_5;
//       case 6:
//         return AppIcons.Dice_6;
//       default:
//         return AppIcons.Dice_1;
//     }
//   };
//   const getDiceButtonStyle = () => {
//     const size = CELL_SIZE * 1.2;
//     const margin = isTablet ? 45 : 20;
//     switch (currentColor) {
//       case "red":
//         return { top: -size - margin, left: 5 };
//       case "blue":
//         return { top: -size - margin, right: 5 };
//       case "green":
//         return { bottom: -size - margin, left: 5 };
//       case "yellow":
//         return { bottom: -size - margin, right: 5 };
//       default:
//         return { top: -size - margin, left: 5 };
//     }
//   };
//   const isTurnForDice = isOnline
//     ? isMyTurn && !gameOver
//     : playingPlayers.length > 0 &&
//       !gameOver &&
//       playingPlayers.includes(currentColor);

//   /**
//    * Render a single cell with optional color
//    */
//   const renderCell = (color?: string, isColorPath: boolean = false) => (
//     <View style={styles.cell} />
//   );
//   return (
//     <ImageBackground source={AppIcons.BoardBackground} style={styles.mainView}>
//       <TouchableOpacity
//         style={styles.backButton}
//         activeOpacity={0.7}
//         onPress={handleLeaveGame}
//       >
//         <Image
//           source={AppIcons.BackIcon}
//           resizeMode="contain"
//           style={styles.backIcon}
//         />
//       </TouchableOpacity>
//       <View style={{ flex: 1, justifyContent: "center" }}>
//         <View style={styles.rowView}>
//           {/* red token and dice */}
//           <View>
//             <View style={styles.tokenView}>
//               <FastImage
//                 // source={AppIcons.OnlineUser}
//                 source={
//                   redColorUser()?.image
//                     ? { uri: redColorUser()?.image }
//                     : AppIcons.OnlineUser
//                 }
//                 style={styles.tokenBack}
//               />
//               {isMyTurn && currentColor == "red" && (
//                 <FastImage
//                   source={AppIcons.DiceBackground}
//                   style={styles.diceBack}
//                 >
//                   <View style={styles.diceview}>
//                     <TouchableOpacity
//                       onPress={canRoll ? onRoll : undefined}
//                       style={[styles.diceview1]}
//                       disabled={!canRoll}
//                     >
//                       {isAnimatingDice ? (
//                         <LottieView
//                           ref={lottieRef}
//                           source={require("../../../src/assets/lottie/dice.json")}
//                           loop={true}
//                           style={[
//                             styles.lottieDice,
//                             { opacity: isAnimatingDice ? 1 : 0 },
//                           ]}
//                           speed={1}
//                         />
//                       ) : dice !== null ? (
//                         <Image
//                           source={getDiceImage(dice)}
//                           style={{
//                             width: isTablet ? 60 : 45,
//                             height: isTablet ? 60 : 45,
//                           }}
//                         />
//                       ) : (
//                         <Image source={AppIcons.Dice} style={styles.dice} />
//                       )}
//                     </TouchableOpacity>
//                   </View>
//                 </FastImage>
//               )}
//             </View>
//             <Text style={styles.name}>
//               {redColorUser()?.name == userData?.name
//                 ? "You"
//                 : redColorUser()?.name}
//             </Text>
//           </View>
//           {/* blue token and dice */}
//           {connectedPlayersInit?.length > 2 ? (
//             <View>
//               <View style={[styles.tokenView, { justifyContent: "flex-end" }]}>
//                 {isMyTurn && currentColor == "blue" && (
//                   <FastImage
//                     source={AppIcons.DiceBackground1}
//                     style={styles.diceBack}
//                   >
//                     <View style={styles.diceview}>
//                       <TouchableOpacity
//                         onPress={canRoll ? onRoll : undefined}
//                         style={[styles.diceview1]}
//                         disabled={!canRoll}
//                       >
//                         {isAnimatingDice ? (
//                           <LottieView
//                             ref={lottieRef}
//                             source={require("../../../src/assets/lottie/dice.json")}
//                             loop={true}
//                             style={[
//                               styles.lottieDice,
//                               { opacity: isAnimatingDice ? 1 : 0 },
//                             ]}
//                             speed={1}
//                           />
//                         ) : dice !== null ? (
//                           <Image
//                             source={getDiceImage(dice)}
//                             style={{
//                               width: isTablet ? 60 : 45,
//                               height: isTablet ? 60 : 45,
//                             }}
//                           />
//                         ) : (
//                           <Image source={AppIcons.Dice} style={styles.dice} />
//                         )}
//                       </TouchableOpacity>
//                     </View>
//                   </FastImage>
//                 )}
//                 <FastImage
//                   // source={AppIcons.OnlineUser}
//                   source={
//                     blueColorUser()?.image
//                       ? { uri: blueColorUser()?.image }
//                       : AppIcons.OnlineUser
//                   }
//                   style={styles.tokenBack}
//                 />
//               </View>
//               <Text style={[styles.name, { alignSelf: "flex-end" }]}>
//                 {blueColorUser()?.name == userData?.name
//                   ? "You"
//                   : blueColorUser()?.name}
//               </Text>
//             </View>
//           ) : (
//             <Spacer row />
//           )}
//         </View>
//         <View style={styles.innerContainer}>
//           {/* Game Board Container */}
//           <View style={styles.boardContainer}>
//             <View style={styles.board}>
//               {/* Render 15x15 grid of cells */}
//               {Array.from({ length: GRID_SIZE }).map((_, row) => (
//                 <View key={row} style={styles.row}>
//                   {Array.from({ length: GRID_SIZE }).map((_, col) => {
//                     return <View key={`${row}-${col}`}>{renderCell()}</View>;
//                   })}
//                 </View>
//               ))}
//               <FastImage
//                 source={isTablet ? AppIcons.LudoBoard : AppIcons.LudoBoard}
//                 style={styles.boardImg}
//               />
//               {activePlayers.includes("red") && (
//                 <View style={[styles.tokenArea, { top: 0, left: 0 }]}>
//                   {allFinishedByColor.red && firstWinner === "red" ? (
//                     <Image
//                       source={AppIcons.KingIcon}
//                       style={styles.crown}
//                       resizeMode="contain"
//                     />
//                   ) : (
//                     renderTokensPile()
//                   )}
//                 </View>
//               )}
//               {activePlayers.includes("blue") && (
//                 <View style={[styles.tokenArea, { top: 0, right: 0 }]}>
//                   {allFinishedByColor.blue && firstWinner === "blue" ? (
//                     <Image
//                       source={AppIcons.KingIcon}
//                       style={styles.crown}
//                       resizeMode="contain"
//                     />
//                   ) : (
//                     renderTokensPile()
//                   )}
//                 </View>
//               )}
//               {activePlayers.includes("green") && (
//                 <View style={[styles.tokenArea, { bottom: 0, left: 0 }]}>
//                   {allFinishedByColor.green && firstWinner === "green" ? (
//                     <Image
//                       source={AppIcons.KingIcon}
//                       style={styles.crown}
//                       resizeMode="contain"
//                     />
//                   ) : (
//                     renderTokensPile()
//                   )}
//                 </View>
//               )}
//               {activePlayers.includes("yellow") && (
//                 <View style={[styles.tokenArea, { bottom: 0, right: 0 }]}>
//                   {allFinishedByColor.yellow && firstWinner === "yellow" ? (
//                     <Image
//                       source={AppIcons.KingIcon}
//                       style={styles.crown}
//                       resizeMode="contain"
//                     />
//                   ) : (
//                     renderTokensPile()
//                   )}
//                 </View>
//               )}
//               {activePlayers.map((color: any) => {
//                 // @ts-ignore
//                 return (tokens[color] || []).map((token) => {
//                   // @ts-ignore
//                   const anim = anims[color] && anims[color][token.id];
//                   if (!anim) return null;
//                   const zIndex = getTokenZIndex(color, token);
//                   return (
//                     <TouchableWithoutFeedback
//                       key={`${color}-${token.id}`}
//                       onPress={() => {
//                         setCanTap(false);
//                         setTimeout(() => setCanTap(true), 2000);
//                         onTokenPress(color, token.id);
//                       }}
//                       disabled={!canTap || !isTurnForDice}
//                     >
//                       <Animated.View
//                         style={[
//                           styles.liveToken,
//                           {
//                             zIndex,
//                             transform: [
//                               { translateX: anim.x },
//                               { translateY: anim.y },
//                             ],
//                           },
//                         ]}
//                       >
//                         <Image
//                           // @ts-ignore
//                           source={PISES_IMAGES[color]}
//                           style={styles.tokenImage}
//                           resizeMode="contain"
//                         />
//                       </Animated.View>
//                     </TouchableWithoutFeedback>
//                   );
//                 });
//               })}
//             </View>
//           </View>
//         </View>
//         <Spacer size={8} />
//         <View style={styles.rowView}>
//           {/* green token and dice */}
//           {connectedPlayersInit?.length > 3 ? (
//             <View>
//               <View style={styles.tokenView}>
//                 <FastImage
//                   // source={AppIcons.OnlineUser}
//                   source={
//                     greenColorUser()?.image
//                       ? { uri: greenColorUser()?.image }
//                       : AppIcons.OnlineUser
//                   }
//                   style={styles.tokenBack}
//                 />
//                 {isMyTurn && currentColor == "green" && (
//                   <FastImage
//                     source={AppIcons.DiceBackground}
//                     style={styles.diceBack}
//                   >
//                     <View style={styles.diceview}>
//                       <TouchableOpacity
//                         onPress={canRoll ? onRoll : undefined}
//                         style={[styles.diceview1]}
//                         disabled={!canRoll}
//                       >
//                         {isAnimatingDice ? (
//                           <LottieView
//                             ref={lottieRef}
//                             source={require("../../../src/assets/lottie/dice.json")}
//                             loop={true}
//                             style={[
//                               styles.lottieDice,
//                               { opacity: isAnimatingDice ? 1 : 0 },
//                             ]}
//                             speed={1}
//                           />
//                         ) : dice !== null ? (
//                           <Image
//                             source={getDiceImage(dice)}
//                             style={{
//                               width: isTablet ? 60 : 45,
//                               height: isTablet ? 60 : 45,
//                             }}
//                           />
//                         ) : (
//                           <Image source={AppIcons.Dice} style={styles.dice} />
//                         )}
//                       </TouchableOpacity>
//                     </View>
//                   </FastImage>
//                 )}
//               </View>
//               <Text style={styles.name}>
//                 {greenColorUser()?.name == userData?.name
//                   ? "You"
//                   : greenColorUser()?.name}
//               </Text>
//             </View>
//           ) : (
//             <Spacer row />
//           )}
//           {/* yellow token and dice */}
//           <View>
//             <View style={[styles.tokenView, { justifyContent: "flex-end" }]}>
//               {isMyTurn && currentColor == "yellow" && (
//                 <FastImage
//                   source={AppIcons.DiceBackground1}
//                   style={styles.diceBack}
//                 >
//                   <View style={styles.diceview}>
//                     <TouchableOpacity
//                       onPress={canRoll ? onRoll : undefined}
//                       style={[
//                         styles.diceview1,
//                         {
//                           marginRight: 25,
//                         },
//                       ]}
//                       disabled={!canRoll}
//                     >
//                       {isAnimatingDice ? (
//                         <LottieView
//                           ref={lottieRef}
//                           source={require("../../../src/assets/lottie/dice.json")}
//                           loop={true}
//                           style={[
//                             styles.lottieDice,
//                             { opacity: isAnimatingDice ? 1 : 0 },
//                           ]}
//                           speed={1}
//                         />
//                       ) : dice !== null ? (
//                         <Image
//                           source={getDiceImage(dice)}
//                           style={{
//                             width: isTablet ? 60 : 45,
//                             height: isTablet ? 60 : 45,
//                           }}
//                         />
//                       ) : (
//                         <Image source={AppIcons.Dice} style={styles.dice} />
//                       )}
//                     </TouchableOpacity>
//                   </View>
//                 </FastImage>
//               )}
//               <FastImage
//                 // source={AppIcons.OnlineUser}
//                 source={
//                   yellowColorUser()?.image
//                     ? { uri: yellowColorUser()?.image }
//                     : AppIcons.OnlineUser
//                 }
//                 style={styles.tokenBack}
//               />
//             </View>
//             <Text style={[styles.name, { alignSelf: "flex-end" }]}>
//               {yellowColorUser()?.name == userData?.name
//                 ? "You"
//                 : yellowColorUser()?.name}
//             </Text>
//           </View>
//         </View>
//         {displayWinners.length > 0 && gameOver && (
//           <LottieView
//             source={require("../../../src/assets/lottie/boom.json")}
//             autoPlay={true}
//             loop={true} // Loop until timer ends
//             style={styles.lottieAnimation}
//           />
//         )}
//         <View style={styles.botttomView}>
//           <BannerAd
//             ref={bannerRef}
//             unitId={bannerAdKey}
//             size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
//           />
//         </View>
//       </View>
//       <GameOverModal
//         visible={gameOver}
//         winners={displayWinners}
//         onRestart={() => {
//           setGameOver(false);
//           setTimeout(() => {
//             restartGame();
//           }, 100);
//         }}
//         onClose={() => {
//           setGameOver(false);
//           setTimeout(() => {
//             restartGame();
//           }, 100);
//         }}
//         isOnline={true}
//         onlinePlayers={connectedPlayersInit}
//       />
//       <VoiceComponent
//         players={connectedPlayers}
//         myColor={myColor}
//         isMuted={isMuted}
//         onToggleMute={handleToggleMute}
//         playerMuteStates={playerMuteStates}
//         remoteStreams={remoteStreams}
//       />
//     </ImageBackground>
//   );
// };

// export default OnlinePlay;

// const styles = StyleSheet.create({
//   mainView: {
//     flex: 1,
//     backgroundColor: AppTheme.colors.boardBack,
//   },
//   backButton: {
//     position: "absolute",
//     top: 70,
//     right: 0,
//     width: 50,
//     height: 40,
//     zIndex: 10,
//   },
//   backIcon: {
//     width: 50,
//     height: 40,
//   },
//   innerContainer: {
//     justifyContent: "center",
//     alignItems: "center",
//     width: "100%",
//   },
//   boardContainer: {
//     position: "relative", // For absolute positioning of dice button
//   },
//   board: {
//     width: BOARD_SIZE,
//     height: BOARD_SIZE,
//   },
//   row: {
//     flexDirection: "row",
//   },
//   cell: {
//     width: CELL_SIZE,
//     height: CELL_SIZE,
//     // borderWidth: 0.5,
//   },
//   boardImg: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: CELL_SIZE * 15,
//     height: CELL_SIZE * 15,
//   },
//   rowView: {
//     width: "100%",
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingHorizontal: 10,
//   },
//   tokenBack: {
//     width: 70,
//     height: 70,
//     paddingLeft: 18,
//     paddingTop: 10,
//     borderRadius:10,
//   },
//   token: {
//     width: 25,
//     height: 45,
//   },
//   tokenView: {
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   diceBack: {
//     width: 72,
//     height: 60,
//     marginBottom: 7,
//     marginHorizontal: 7,
//   },
//   dice: {
//     width: 46,
//     height: 46,
//   },
//   diceview: {
//     width: "83%",
//     height: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//     alignSelf: "flex-end",
//   },
//   name: {
//     fontSize: 18,
//     color: AppTheme.colors.white,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
//     marginBottom: 7,
//   },
//   diceview1: {
//     width: "85%",
//     height: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   tokenArea: {
//     position: "absolute",
//     width: CELL_SIZE * 6,
//     height: CELL_SIZE * 6,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   tokensGrid: {
//     width: "70%",
//     height: "70%",
//     flexDirection: "row",
//     flexWrap: "wrap",
//     justifyContent: "space-between",
//     alignContent: "space-between",
//   },
//   crown: {
//     width: "70%",
//     height: "70%",
//   },
//   floatingDiceButton: {
//     position: "absolute",
//     zIndex: 1000,
//   },
//   lottieDice: {
//     width: isTablet ? CELL_SIZE * 2.5 : CELL_SIZE * 2.8,
//     height: isTablet ? CELL_SIZE * 2.5 : CELL_SIZE * 2.8,
//     // marginTop: ,
//   },
//   controls: {
//     marginTop: 20,
//     alignItems: "center",
//   },
//   playerText: {
//     fontSize: 22,
//     fontWeight: "bold",
//     marginBottom: 12,
//   },
//   buttonRow: {
//     flexDirection: "row",
//     marginTop: 8,
//   },
//   lottieAnimation: {
//     height: 440,
//     // width: 440,
//     position: "absolute",
//     top: -50,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     margin: "auto",
//   },
//   liveToken: {
//     position: "absolute",
//     width: TOKEN_SIZE,
//     height: TOKEN_SIZE,
//     borderRadius: TOKEN_SIZE / 2,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   tokenImage: {
//     width: isTablet ? 50 : 28, // Scale to fit within token container
//     height: isTablet ? 50 : 28,
//     marginBottom: 10,
//   },
//   botttomView: {
//     position: "absolute",
//     bottom: 10,
//   },
//   centerView: {
//     position: "absolute",
//     // zIndex: 9999,
//     width: CELL_SIZE * 3,
//     height: CELL_SIZE * 3,
//     top: CELL_SIZE * 6,
//     right: CELL_SIZE * 6,
//   },
//   backBtn: {
//     position: "absolute",
//     top: 70,
//     left: 20,
//   },
//   backImg: {
//     width: 40,
//     height: 40,
//   },
// });

import {
  Alert,
  Animated,
  BackHandler,
  DeviceEventEmitter,
  Dimensions,
  Image,
  ImageBackground,
  NativeEventSubscription,
  PermissionsAndroid,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AppIcons } from "../../assets/images";
import { AppTheme } from "../../utils/theme";
import { useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import FastImage from "react-native-fast-image";
import DeviceInfo from "react-native-device-info";
import Spacer from "../../components/global/Spacer";
import {
  checkPlayerWin,
  endTurn,
  initGame,
  LudoState,
  moveTokenSteps,
  PlayerColor,
  rollDice,
  setCanRoll,
  setCurrentPlayerIndex,
  setDice,
  Token,
} from "../../redux/ludoSlice";
import {
  BlueColorPath,
  Coordinate,
  GreenColorPath,
  RedColorPath,
  YellowColorPath,
} from "../../utils/ludoPaths";
import { useAppSelector } from "../../redux/storeHook";
import LottieView from "lottie-react-native";
import {
  AdEventType,
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";
import { useDispatch, useSelector, useStore } from "react-redux";
import socketService from "../../services/socketService";
import webRTCService from "../../services/webRTCService";
import SoundPlayer from "react-native-sound-player";
import { ROUTE_NAME } from "../../utils/routes";
import { bannerAdKey, interstitial } from "../../utils/contants";
import { setAppOpenAdPaused } from "../../utils/useOpenAppAd";
import GameOverModal from "../../components/GameOverModal";
import VoiceComponent from "../../components/VoiceComponent";
import {
  activateKeepAwake,
  deactivateKeepAwake,
} from "@sayem314/react-native-keep-awake";
import { userAction } from "../../redux/reducers/user";

import { NativeModules, NativeEventEmitter } from "react-native";

const BluetoothAudio = NativeModules?.BluetoothAudio;
const eventEmitter =
  BluetoothAudio && typeof NativeEventEmitter === "function" && Platform.OS !== "web"
    ? new NativeEventEmitter(BluetoothAudio)
    : { addListener: () => ({ remove: () => {} }) };

// Start automatic management when call begins
const startAudioManagement = () => {
  BluetoothAudio?.startListening?.();
  console.log("Audio management started - auto-routing to BT or speaker");
};

// Stop when call ends
const stopAudioManagement = () => {
  BluetoothAudio?.stopListening?.();
};

// Optional: Listen for changes (e.g., UI updates)
// useEffect(() => {
//   const subscription = eventEmitter.addListener('BluetoothAudioChanged', (isConnected: boolean) => {
//     console.log(`BT changed: ${isConnected ? 'Routed to Bluetooth' : 'Routed to Speaker'}`);
//     // Update UI, e.g., show BT icon
//   });

//   return () => subscription.remove();
// }, []);

const screenWidth =
  Platform.OS === "web"
    ? Math.min(Dimensions.get("window").width, 480)
    : Dimensions.get("window").width;
const BOARD_SIZE = Math.min(screenWidth * 0.95, 450); // Board takes 95% of screen width
const GRID_SIZE = 15; // 15x15 grid for Ludo board
const CELL_SIZE = BOARD_SIZE / GRID_SIZE; // Size of each cell
const HOME_FINISH_OFFSET = CELL_SIZE * 0.2;
const isTablet = DeviceInfo.isTablet();

// Piece images for each color
const PISES_IMAGES = {
  red: AppIcons.RedToken,
  blue: AppIcons.BlueToken,
  green: AppIcons.GreenToken,
  yellow: AppIcons.YellowToken,
};

// Path definitions for each player's tokens
const PATHS: Record<PlayerColor, Coordinate[]> = {
  red: RedColorPath,
  blue: BlueColorPath,
  green: GreenColorPath,
  yellow: YellowColorPath,
};

const TOKEN_SIZE = CELL_SIZE * 0.8;
const TOKEN_OFFSET = (CELL_SIZE - TOKEN_SIZE) / 2;
const STACK_OFFSET = CELL_SIZE * 0.15;

// Home turn coordinates
const HOME_TURN_COORDS: Record<PlayerColor, Coordinate> = {
  red: [7, 0],
  blue: [0, 7],
  yellow: [7, 14],
  green: [14, 7],
};

interface PixelPosition {
  x: number;
  y: number;
}

const cellToPixel = (row: number, col: number): PixelPosition => ({
  x: col * CELL_SIZE,
  y: row * CELL_SIZE,
});

const tokenAreaTopLeft: Record<PlayerColor, PixelPosition> = {
  red: { x: 0, y: 0 },
  blue: { x: BOARD_SIZE - CELL_SIZE * 6, y: 0 },
  green: { x: 0, y: BOARD_SIZE - CELL_SIZE * 6 },
  yellow: { x: BOARD_SIZE - CELL_SIZE * 6, y: BOARD_SIZE - CELL_SIZE * 6 },
};

const homePixelFor = (color: PlayerColor, tokenId: number): PixelPosition => {
  const areaSize = CELL_SIZE * 6;
  const area = tokenAreaTopLeft[color];
  const padding = (areaSize - 3 * TOKEN_SIZE) / 3;
  const col = tokenId % 2;
  const row = tokenId < 2 ? 0 : 1;
  const x = area.x + padding + col * (TOKEN_SIZE + padding);
  const y = area.y + padding + row * (TOKEN_SIZE + padding);
  // return { x: x - 2, y: y - 2 };
  return {
    x: isTablet
      ? tokenId == 0 || tokenId == 2
        ? x + 20
        : x + 10
      : tokenId == 0 || tokenId == 2
      ? x + 10
      : x + 5,
    y: tokenId == 2 || tokenId == 3 ? y + 3 : y + 8,
  };
};

const getFinishedOffset = (
  tokens: Record<PlayerColor, Token[]>,
  color: PlayerColor,
  tokenId: number
): { offX: number; offY: number } => {
  const finishedTokens = (tokens[color] || [])
    .filter((t) => t.status === "finished")
    .sort((a, b) => a.id - b.id);

  const numFinished = finishedTokens.length;

  const tokenIndex = finishedTokens.findIndex((t) => t.id === tokenId);

  if (tokenIndex === -1 || numFinished === 0) {
    return { offX: 0, offY: 0 };
  }

  const pOff = HOME_FINISH_OFFSET;

  let offX = 0;

  let offY = 0;

  switch (numFinished) {
    case 2:
      offX = tokenIndex === 0 ? -pOff : pOff;

      offY = 0;

      break;

    case 3:
      if (tokenIndex === 0) {
        offX = -pOff;

        offY = pOff * 0.5;
      } else if (tokenIndex === 1) {
        offX = pOff;

        offY = pOff * 0.5;
      } else {
        offX = 0;

        offY = -pOff * 1.5;
      }

      break;

    case 4:
      if (tokenIndex === 0) {
        offX = -pOff;

        offY = pOff;
      } else if (tokenIndex === 1) {
        offX = pOff;

        offY = pOff;
      } else if (tokenIndex === 2) {
        offX = -pOff;

        offY = -pOff;
      } else {
        offX = pOff;

        offY = -pOff;
      }

      break;
  }

  return { offX, offY };
};

interface TokenWithColor {
  color: PlayerColor;
  token: Token;
}

interface AppState {
  ludo: LudoState;
}

const getActivePlayers = (num: number): PlayerColor[] => {
  switch (num) {
    case 2:
      return ["red", "yellow"];
    case 3:
      return ["red", "blue", "yellow"];
    case 4:
      return ["red", "blue", "yellow", "green"];
    default:
      return ["red", "blue", "yellow", "green"];
  }
};

const OnlinePlay = () => {
  const route: any = useRoute();
  const { userData } = useAppSelector((s) => s.user);
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const isOnline = !!route?.params?.roomId;
  const onlineParams = isOnline ? route.params : {};
  const {
    roomId,
    playerName,
    myColor: onlineMyColor,
    players: connectedPlayersInit,
    numPlayers: onlineNumPlayers,
  } = onlineParams;
  console.log("@ online params : ", onlineParams);
  // Local mode state
  const [numPlayers, setNumPlayers] = useState<number | null>(
    isOnline ? onlineNumPlayers : null
  );
  // Online-specific state
  const [chatMessages, setChatMessages] = useState([]);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [playerMuteStates, setPlayerMuteStates] = useState({});
  const [connectedPlayers, setConnectedPlayers] = useState(
    connectedPlayersInit || []
  );
  const [isMyTurn, setIsMyTurn] = useState(false);
  const [autoEnding, setAutoEnding] = useState(false);
  const [remoteStreams, setRemoteStreams] = useState(new Map());
  // Shared game state
  const [gameOver, setGameOver] = useState(false);
  const [displayWinners, setDisplayWinners] = useState<PlayerColor[]>([]);
  const [isAnimatingDice, setIsAnimatingDice] = useState(false);
  const [canTap, setCanTap] = useState(true);
  const [firstWinner, setFirstWinner] = useState<PlayerColor | null>(null);
  const [isTokenMoving, setIsTokenMoving] = useState(false);

  const { isSoundOn } = useAppSelector((state) => state.user);
  const lottieRef = useRef<LottieView>(null);
  const bannerRef = useRef<BannerAd>(null);
  const dispatch = useDispatch();
  const store = useStore();
  const state = useSelector((s: AppState) => s.ludo);
  const {
    tokens,
    paths,
    currentPlayerIndex,
    dice,
    winners,
    canRoll,
    capturedToken,
    tokenReachedHome,
    consecutiveSixes,
    isReturnInProgress,
  } = state;
  // Determine activePlayers
  const activePlayers = useMemo(() => {
    if (isOnline) {
      return connectedPlayers.map((p: any) => p.color);
    }
    return numPlayers ? getActivePlayers(numPlayers) : [];
  }, [isOnline, connectedPlayers, numPlayers]);
  const playingPlayers = useMemo(
    () => activePlayers.filter((p: any) => !winners.includes(p)),
    [activePlayers, winners]
  );
  const effectiveCurrentIndex = currentPlayerIndex % activePlayers.length;
  const currentColor = activePlayers[effectiveCurrentIndex] || "red";
  const myColor = isOnline ? onlineMyColor : currentColor;
  // Check if it's my turn (online only)

  const allFinishedByColor = useMemo(() => {
    //@ts-ignore
    const finished: Record<PlayerColor, boolean> = {};
    //@ts-ignore
    activePlayers.forEach((color) => {
      //@ts-ignore
      finished[color] = (tokens[color] || []).every(
        //@ts-ignore
        (t) => t.status === "finished"
      );
    });
    return finished;
  }, [tokens, activePlayers]);
  useEffect(() => {
    if (isOnline) {
      setIsMyTurn(currentColor === myColor && !gameOver);
    }
  }, [currentColor, myColor, gameOver, isOnline]);

  const anims = useRef<Record<PlayerColor, Record<number, Animated.ValueXY>>>({
    red: {},
    blue: {},
    green: {},
    yellow: {},
  }).current;

  useEffect(() => {
    DeviceEventEmitter.addListener("Proximity", function (data) {
      // --- do something with events
      console.log("@ Proximity : ", data);
    });
  }, []);

  useEffect(() => {
    userAction.setTouchSound(true); // Trigger touch sound on start
    userAction.setMusicPreference(false); // Stop music for game
  }, []);

  // color names
  const redColorUser = useCallback(() => {
    const findUser = connectedPlayersInit?.find((e: any) => e?.color == "red");
    if (findUser) {
      return { name: findUser?.name, image: findUser?.profilePhoto };
    }
    return { name: "", image: "" };
  }, [connectedPlayersInit]);

  const blueColorUser = useCallback(() => {
    const findUser = connectedPlayersInit?.find((e: any) => e?.color == "blue");
    if (findUser) {
      return { name: findUser?.name, image: findUser?.profilePhoto };
    }
    return { name: "", image: "" };
  }, [connectedPlayersInit]);

  const yellowColorUser = useCallback(() => {
    const findUser = connectedPlayersInit?.find(
      (e: any) => e?.color == "yellow"
    );
    if (findUser) {
      return { name: findUser?.name, image: findUser?.profilePhoto };
    }
    return { name: "", image: "" };
  }, [connectedPlayersInit]);

  const greenColorUser = useCallback(() => {
    const findUser = connectedPlayersInit?.find(
      (e: any) => e?.color == "green"
    );
    if (findUser) {
      return { name: findUser?.name, image: findUser?.profilePhoto };
    }
    return { name: "", image: "" };
  }, [connectedPlayersInit]);
  // Game over logic
  useEffect(() => {
    let finalWinners: PlayerColor[] = winners.filter((w) =>
      activePlayers.includes(w)
    );
    if (winners.length > 0 && firstWinner === null) {
      setFirstWinner(winners[0]);
    }
    if (playingPlayers.length === 1) {
      finalWinners = [...finalWinners, playingPlayers[0]];
      setGameOver(true);
    } else if (playingPlayers.length === 0) {
      setGameOver(true);
    }
    setDisplayWinners(finalWinners);
  }, [winners, activePlayers, playingPlayers]);

  // Optional: Listen for changes (e.g., UI updates)
  useEffect(() => {
    const subscription = eventEmitter.addListener(
      "BluetoothAudioChanged",
      (isConnected: boolean) => {
        console.log(
          `BT changed: ${
            isConnected ? "Routed to Bluetooth" : "Routed to Speaker"
          }`
        );
        userAction.setMusicPreference(false);
        userAction.setTouchSound(true);
        userAction.setPlayGame(true);
        // Update UI, e.g., show BT icon
      }
    );

    return () => subscription.remove();
  }, []);
  // Auto end turn if no legal moves (shared, but conditional)
  useEffect(() => {
    const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
    const playerColor = isOnline ? myColor : currentColor;
    if (
      isTurn &&
      dice !== null &&
      !isAnimatingDice &&
      !autoEnding &&
      !gameOver
    ) {
      const legal = getLegalMoves(playerColor, dice);
      if (legal.length === 0) {
        setAutoEnding(true);
        setTimeout(() => {
          dispatch(setDice(null));
          endActiveTurn();
          setAutoEnding(false);
        }, 1200);
      }
    }
  }, [
    dice,
    currentPlayerIndex,
    isMyTurn,
    isAnimatingDice,
    autoEnding,
    myColor,
    currentColor,
    gameOver,
  ]);
  // Auto-move if only one legal move (shared, conditional)
  useEffect(() => {
    const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
    const playerColor = isOnline ? myColor : currentColor;
    if (!isTurn || dice == null || gameOver || autoEnding) return;
    const legal = getLegalMoves(playerColor, dice);
    if (dice === 6 && consecutiveSixes >= 3) {
      setTimeout(() => {
        dispatch(setDice(null));
        endActiveTurn();
      }, 400);
      return;
    }
    if (legal.length === 0) return; // Handled in previous effect
    if (legal.length === 1) {
      const only = legal[0];
      const moveSteps = only.action === "bringOut" ? "bringOut" : dice;
      setIsTokenMoving(true);
      if (isOnline) {
        socketService.emitTokenMove(roomId, {
          color: playerColor,
          tokenId: only.tokenId,
          steps: moveSteps,
        });
      }
      dispatch(
        moveTokenSteps({
          color: playerColor,
          tokenId: only.tokenId,
          steps: moveSteps,
        }) as any
      ).then(() => {
        setTimeout(() => {
          setIsTokenMoving(false);
        }, 240);
        //@ts-ignore
        const stateAfterMove = store.getState().ludo;
        const wasCaptured = stateAfterMove.capturedToken;
        dispatch(checkPlayerWin({ color: playerColor }));
        //@ts-ignore
        const stateAfterCheck = store.getState().ludo;
        const reachedHome = stateAfterCheck.tokenReachedHome;
        const updatedWinners = stateAfterCheck.winners;
        const updatedPlayingPlayers = activePlayers.filter(
          (p: any) => !updatedWinners.includes(p)
        );
        dispatch(setDice(null));
        if (updatedPlayingPlayers.length === 0) {
          setGameOver(true);
          return;
        }
        if (updatedWinners.includes(playerColor)) {
          endActiveTurn();
        } else {
          if (wasCaptured || reachedHome || dice === 6) {
            dispatch(setCanRoll(true));
          } else {
            endActiveTurn();
          }
        }
      });
    }
  }, [
    dice,
    currentPlayerIndex,
    isMyTurn,
    gameOver,
    autoEnding,
    myColor,
    currentColor,
    consecutiveSixes,
    isOnline,
    roomId,
    store,
    activePlayers,
    playingPlayers,
  ]);
  // Online initialization
  useEffect(() => {
    if (isOnline) {
      initializeOnlineFeatures();
      setupSocketListeners();
      setupWebRTC();
      return () => {
        cleanup();
      };
    }
  }, [isOnline]);
  const initializeOnlineFeatures = () => {
    dispatch(initGame(activePlayers));
  };
  const setupSocketListeners = () => {
    //@ts-ignore
    socketService.onOpponentDiceRolled(({ diceValue, playerId }) => {
      console.log(`Opponent rolled: ${diceValue}`);
      dispatch(setDice(diceValue));
      dispatch(setCanRoll(false));
    });
    //@ts-ignore
    socketService.onOpponentTokenMoved(({ moveData }) => {
      const { color, tokenId, steps } = moveData;
      dispatch(moveTokenSteps({ color, tokenId, steps }) as any)
        .then(() => {
          dispatch(checkPlayerWin({ color }));
        })
        .catch((error: any) => {
          console.error("Error handling opponent move:", error);
        });
    });
    socketService.onAdvanceTurn?.(() => {
      dispatch(endTurn());
    });
    //@ts-ignore
    socketService.onGameOver(({ winner, reason }) => {
      setDisplayWinners([winner.color]);
      setGameOver(true);
    });
    // @ts-ignore
    socketService.onGameStateUpdated(({ gameState }) => {
      console.log("Game state updated from server");
    });
    socketService.onNewMessage((message: any) => {
      //@ts-ignore
      setChatMessages((prev) => [...prev, message]);
    });
    //@ts-ignore
    socketService.onPlayerLeft(({ playerId, room }) => {
      const disconnectedPlayer = connectedPlayers.find(
        (p: any) => p.id === playerId
      );
      if (disconnectedPlayer) {
        console.log("@ disconnect");
      }
      if (room && room.players) {
        setConnectedPlayers(room.players);
      }
    });
    //@ts-ignore
    socketService.onPlayerMuteChanged(({ playerId, isMuted }) => {
      setPlayerMuteStates((prev) => ({
        ...prev,
        [playerId]: isMuted,
      }));
    });
  };
  const setupWebRTC = async () => {
    try {
      if (Platform.OS === "android") {
        setAppOpenAdPaused(true);
        const granted = await PermissionsAndroid.request(
          PermissionsAndroid.PERMISSIONS.RECORD_AUDIO,
          {
            title: "Microphone Permission",
            message: "This app needs microphone access for voice chat.",
            buttonNeutral: "Ask Me Later",
            buttonNegative: "Cancel",
            buttonPositive: "OK",
          }
        );
        setAppOpenAdPaused(false, 1000);
        if (granted !== PermissionsAndroid.RESULTS.GRANTED) {
          throw new Error("Microphone permission denied");
        }
      }
      // InCallManager.start({ media: "audio" });
      // InCallManager.setForceSpeakerphoneOn(true);
      // InCallManager.setSpeakerphoneOn(true);
      // console.log("Loudspeaker automatically enabled");
      // IncallManagerLight.disableProximity()
      await webRTCService.getLocalStream();
      setTimeout(() => {
        startAudioManagement();
      }, 3000);
      //@ts-ignore
      webRTCService.setOnIceCandidate((peerId, candidate) => {
        socketService.sendICECandidate(roomId, candidate, peerId);
      });
      //@ts-ignore
      const handleRemoteStream = (peerId, remoteStream) => {
        console.log(`Stream callback: Playing audio from ${peerId}`);
        setRemoteStreams((prev) => new Map(prev).set(peerId, remoteStream));
      };
      webRTCService.setOnRemoteStreamAdded(handleRemoteStream);
      //@ts-ignore
      socketService.onWebRTCOffer(async ({ offer, senderId }) => {
        const answer = await webRTCService.handleOffer(
          senderId,
          offer,
          handleRemoteStream
        );
        if (answer) {
          socketService.sendWebRTCAnswer(roomId, answer, senderId);
        }
      });
      //@ts-ignore
      socketService.onWebRTCAnswer(async ({ answer, senderId }) => {
        await webRTCService.handleAnswer(senderId, answer);
      });
      //@ts-ignore
      socketService.onICECandidate(async ({ candidate, senderId }) => {
        await webRTCService.handleICECandidate(senderId, candidate);
      });
      for (const player of connectedPlayers) {
        if (player.color !== myColor) {
          const pc = webRTCService.createPeerConnection(
            player.id,
            handleRemoteStream
          );
          //@ts-ignore
          const isHost = connectedPlayers[0].id === socketService?.socket?.id;
          if (isHost) {
            const offer = await webRTCService.createOffer(player.id);
            if (offer) {
              socketService.sendWebRTCOffer(roomId, offer, player.id);
            }
          }
        }
      }
    } catch (error: any) {
      console.error("WebRTC setup failed:", error);
      Alert.alert(
        "Voice Chat",
        `Voice chat could not be initialized: ${error.message}`
      );
    }
  };
  const cleanup = () => {
    if (isOnline) {
      webRTCService.cleanup();
      socketService.removeAllListeners();
      stopAudioManagement();
      // InCallManager.stop();
      // InCallManager.setForceSpeakerphoneOn(false);
      // InCallManager.setSpeakerphoneOn(false);
      setRemoteStreams(new Map());
    }
  };
  // Shared endActiveTurn
  const endActiveTurn = useCallback(() => {
    if (!activePlayers.length) return;
    let currentEffective = currentPlayerIndex % activePlayers.length;
    let nextEffective = (currentEffective + 1) % activePlayers.length;
    while (winners.includes(activePlayers[nextEffective])) {
      nextEffective = (nextEffective + 1) % activePlayers.length;
      if (nextEffective === currentEffective) {
        setGameOver(true);
        return;
      }
    }
    dispatch(endTurn());
    dispatch(setCurrentPlayerIndex(nextEffective));
    if (isOnline) {
      socketService.advanceTurn(roomId);
    }
  }, [
    dispatch,
    currentPlayerIndex,
    activePlayers,
    winners,
    setGameOver,
    isOnline,
    roomId,
  ]);
  // Dice roll handler (sets animation, dispatch in useEffect)
  const onRoll = useCallback(() => {
    const isTurn = isOnline ? isMyTurn : playingPlayers.includes(currentColor);
    if (!isTurn || gameOver || isAnimatingDice) return;
    setIsAnimatingDice(true);
  }, [
    isMyTurn,
    gameOver,
    isAnimatingDice,
    playingPlayers,
    currentColor,
    isOnline,
  ]);
  // Dice animation useEffect (shared)
  useEffect(() => {
    if (!isAnimatingDice) return;

    // Play Lottie animation
    if (lottieRef.current) {
      lottieRef.current.play(0, -1);
    }

    // Dice sound setup (enabled for both online and local)
    let diceSub: NativeEventSubscription | null = null;
    let localIsDiceLooping = false;
    if (isSoundOn) {
      localIsDiceLooping = true;
      diceSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
        if (localIsDiceLooping && isSoundOn) {
          try {
            SoundPlayer.playSoundFile("dise", "mp3");
          } catch (error) {}
        }
      });
      try {
        SoundPlayer.playSoundFile("dise", "mp3");
      } catch (error) {}
    }

    const timer = setTimeout(async () => {
      const result = await dispatch(rollDice() as any);
      const diceValue = result.payload;
      if (isOnline) {
        socketService.emitDiceRoll(
          roomId,
          diceValue,
          //@ts-ignore
          socketService.socket.id
        );
      }
      //@ts-ignore
      const afterState = store?.getState()?.ludo;
      if (afterState.consecutiveSixes >= 3) {
        dispatch(setDice(null));
        endActiveTurn();
      }
      setIsAnimatingDice(false);
      if (lottieRef.current) {
        lottieRef.current.reset();
      }
      // Stop dice sound
      localIsDiceLooping = false;
      if (diceSub) {
        diceSub.remove();
        diceSub = null;
      }
      try {
        SoundPlayer.stop();
      } catch (error) {}
    }, 1000);

    return () => {
      // Cleanup on unmount or re-run
      if (timer) clearTimeout(timer);
      localIsDiceLooping = false;
      if (diceSub) {
        diceSub.remove();
        diceSub = null;
      }
      try {
        SoundPlayer.stop();
      } catch (error) {}
      if (lottieRef.current) {
        lottieRef.current.reset();
      }
    };
  }, [
    isAnimatingDice,
    dispatch,
    roomId,
    store,
    isOnline,
    isSoundOn,
    endActiveTurn,
  ]);
  // Token movement sound
  useEffect(() => {
    if (!isTokenMoving || !isSoundOn) return;

    let pieceSub: NativeEventSubscription | null = null;
    pieceSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
      if (isTokenMoving && isSoundOn) {
        try {
          SoundPlayer.playSoundFile("pice", "mp3");
        } catch (error) {}
      }
    });
    try {
      SoundPlayer.playSoundFile("pice", "mp3");
    } catch (error) {}

    return () => {
      if (pieceSub) {
        pieceSub.remove();
      }
      try {
        SoundPlayer.stop();
      } catch (error) {}
    };
  }, [isTokenMoving, isSoundOn]);
  // Token press handler (conditional)
  const onTokenPress = useCallback(
    (color: PlayerColor, tokenId: number) => {
      const isTurn = isOnline
        ? isMyTurn
        : playingPlayers.includes(currentColor);
      const playerColor = isOnline ? myColor : currentColor;
      if (!isTurn || color !== playerColor || dice == null || gameOver) return;
      if (dice === 6 && consecutiveSixes >= 3) {
        dispatch(setDice(null));
        endActiveTurn();
        return;
      }
      const legal = getLegalMoves(color, dice);
      const chosen = legal.find((m) => m.tokenId === tokenId);
      if (!chosen) {
        if (legal.length === 0) {
          dispatch(setDice(null));
          endActiveTurn();
        } else {
          console.log("Invalid move! Try another token.");
        }
        return;
      }
      const moveSteps = chosen.action === "bringOut" ? "bringOut" : dice;
      setIsTokenMoving(true);
      if (isOnline) {
        socketService.emitTokenMove(roomId, {
          color,
          tokenId,
          steps: moveSteps,
        });
      }
      dispatch(
        moveTokenSteps({ color, tokenId, steps: moveSteps }) as any
      ).then(() => {
        setTimeout(() => {
          setIsTokenMoving(false);
        }, 240);
        //@ts-ignore
        const stateAfterMove = store?.getState()?.ludo;
        const wasCaptured = stateAfterMove.capturedToken;
        dispatch(checkPlayerWin({ color }));
        //@ts-ignore
        const stateAfterCheck = store?.getState()?.ludo;
        const reachedHome = stateAfterCheck.tokenReachedHome;
        const updatedWinners = stateAfterCheck.winners;
        const updatedPlayingPlayers = activePlayers.filter(
          (p: any) => !updatedWinners.includes(p)
        );
        dispatch(setDice(null));
        if (updatedPlayingPlayers.length === 0) {
          setGameOver(true);
          return;
        }
        if (updatedWinners.includes(color)) {
          endActiveTurn();
        } else {
          if (wasCaptured || reachedHome || dice === 6) {
            dispatch(setCanRoll(true));
          } else {
            endActiveTurn();
          }
        }
      });
    },
    [
      isMyTurn,
      myColor,
      currentColor,
      dice,
      consecutiveSixes,
      gameOver,
      dispatch,
      roomId,
      store,
      activePlayers,
      playingPlayers,
      isOnline,
      endActiveTurn,
    ]
  );
  // Online chat/voice handlers
  const handleSendMessage = (message: any) => {
    if (!isOnline) return;
    socketService.sendMessage(roomId, message, playerName);
  };
  const toggleChat = () => {
    if (!isOnline) return;
    setIsChatVisible(!isChatVisible);
  };
  const handleToggleMute = () => {
    if (!isOnline) return;
    const newMuteState = webRTCService.toggleMute();
    setIsMuted(newMuteState);
    socketService.toggleMute(roomId, newMuteState);
  };
  // Back/leave handlers
  const handleLeaveGame = () => {
    if (!isOnline) {
      Alert.alert(
        "Exit Game",
        "Are you sure you want to exit the current game?",
        [
          { text: "Cancel", style: "cancel" },
          {
            text: "Exit",
            style: "destructive",
            onPress: () => {
              try {
                SoundPlayer.stop();
                // userAction.setTouchSound(true);
              } catch (error) {}
              navigation.goBack();
            },
          },
        ]
      );
      return;
    }
    Alert.alert(
      "Leave Game",
      "Are you sure you want to leave? This will disconnect you from the game.",
      [
        { text: "Cancel", style: "cancel" },
        {
          text: "Leave",
          style: "destructive",
          onPress: () => {
            SoundPlayer.stop();
            socketService.leaveRoom(roomId);
            cleanup();
            setTimeout(() => {
              userAction.setTouchSound(true);
              userAction.setMusicPreference(true);
              userAction.setPlayGame(false);
              navigation.replace(ROUTE_NAME.PlayerRoom);
            }, 500);
          },
        },
      ]
    );
  };
  // Restart handler
  const restartGame = () => {
    SoundPlayer.stop();
    socketService.leaveRoom(roomId);
    setGameOver(false);
    setFirstWinner(null);
    cleanup();
    userAction.setTouchSound(true);
    userAction.setMusicPreference(true);
    userAction.setPlayGame(false);
    navigation.replace(ROUTE_NAME.PlayerRoom);
  };
  // Token cut sound
  useEffect(() => {
    if (isReturnInProgress && isSoundOn) {
      SoundPlayer.stop();
      const timer = setTimeout(() => {
        try {
          SoundPlayer.playSoundFile("cutpice", "mp3");
        } catch (error) {
          console.log("Error playing cutpice sound:", error);
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isReturnInProgress, isSoundOn]);
  // Game over sound
  useEffect(() => {
    if (gameOver && displayWinners.length > 0 && isSoundOn) {
      SoundPlayer.stop();
      const timer = setTimeout(() => {
        let boomSub: NativeEventSubscription | null = null;
        boomSub = SoundPlayer.addEventListener("FinishedPlaying", () => {
          if (gameOver && isSoundOn) {
            try {
              SoundPlayer.playSoundFile("boom", "mp3");
            } catch (error) {
              console.log("Error playing boom sound:", error);
            }
          }
        });
        try {
          SoundPlayer.playSoundFile("boom", "mp3");
        } catch (error) {
          console.log("Error playing boom sound:", error);
        }
        return () => {
          if (boomSub) {
            boomSub.remove();
          }
          try {
            SoundPlayer.stop();
          } catch (error) {}
        };
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [gameOver, displayWinners, isSoundOn]);
  // Back handler (local only)
  useEffect(() => {
    // if (!isOnline && numPlayers) {
    const onBackPress = () => {
      Alert.alert(
        "Leave Game",
        "Are you sure you want to leave? This will disconnect you from the game.",
        [
          { text: "Cancel", style: "cancel" },
          {
            text: "Leave",
            style: "destructive",
            onPress: () => {
              SoundPlayer.stop();
              socketService.leaveRoom(roomId);
              cleanup();
              navigation.replace(ROUTE_NAME.PlayerRoom);
            },
          },
        ]
      );
      return true;
    };
    const subscription = BackHandler.addEventListener(
      "hardwareBackPress",
      onBackPress
    );
    return () => subscription.remove();
    // }
  }, [numPlayers, isOnline, navigation]);
  // Ads (shared)
  useForeground(() => {
    Platform.OS === "ios" && bannerRef.current?.load();
  });
  // useEffect(() => {
  //   const unsubscribeLoaded = interstitial.addAdEventListener(
  //     AdEventType.LOADED,
  //     () => {
  //       console.log("@ interstitial ad loaded");
  //     }
  //   );
  //   const unsubscribeOpened = interstitial.addAdEventListener(
  //     AdEventType.OPENED,
  //     () => {
  //       console.log("@ interstitial ad opened");
  //     }
  //   );
  //   const unsubscribeClosed = interstitial.addAdEventListener(
  //     AdEventType.CLOSED,
  //     () => {
  //       console.log("@ interstitial ad closed");
  //     }
  //   );
  //   // interstitial.load();
  //   return () => {
  //     unsubscribeLoaded();
  //     unsubscribeOpened();
  //     unsubscribeClosed();
  //   };
  // }, []);
  // Initialize game (conditional)
  useEffect(() => {
    if (numPlayers !== null) {
      const playersToInit = isOnline
        ? activePlayers
        : getActivePlayers(numPlayers);
      dispatch(initGame(playersToInit));
    }
  }, [numPlayers, isOnline]);
  // Animation initialization (shared)
  useEffect(() => {
    if (numPlayers === null) return;
    //@ts-ignore
    activePlayers.forEach((color) => {
      //@ts-ignore
      if (!anims[color]) anims[color] = {};
      //@ts-ignore
      const path = paths[color] || PATHS[color] || [];
      //@ts-ignore
      (tokens[color] || []).forEach((tok) => {
        //@ts-ignore
        if (!anims[color][tok.id]) {
          let pos: PixelPosition = { x: 0, y: 0 };
          if (tok.status === "onpath") {
            const coord = path[tok.pathIndex];
            pos = cellToPixel(coord[0], coord[1]);
          } else {
            if (tok.status === "home" || tok.status === "returning") {
              pos = homePixelFor(color, tok.id);
            } else if (tok.status === "finished") {
              const last = path[path.length - 1];
              let basePos = cellToPixel(last[0], last[1]);
              const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
              basePos.x += offX;
              basePos.y += offY;
              pos = basePos;
            }
          }
          //@ts-ignore
          anims[color][tok.id] = new Animated.ValueXY({
            x: pos.x + TOKEN_OFFSET,
            y: pos.y + TOKEN_OFFSET,
          });
        }
      });
    });
  }, [numPlayers]);
  // Token animation (shared)
  useEffect(() => {
    if (numPlayers === null) return;
    //@ts-ignore
    activePlayers.forEach((color) => {
      //@ts-ignore
      const path = paths[color] || PATHS[color] || [];
      //@ts-ignore
      (tokens[color] || []).forEach((tok) => {
        //@ts-ignore
        const a = anims[color] && anims[color][tok.id];
        if (!a) return;
        let dest: PixelPosition = { x: 0, y: 0 };
        if (tok.status === "onpath") {
          const coord = path[tok.pathIndex];
          dest = cellToPixel(coord[0], coord[1]);
        } else if (tok.status === "home") {
          dest = homePixelFor(color, tok.id);
        } else if (tok.status === "returning") {
          if (tok.pathIndex >= 0 && tok.pathIndex < path.length) {
            const coord = path[tok.pathIndex];
            dest = cellToPixel(coord[0], coord[1]);
          } else {
            dest = homePixelFor(color, tok.id);
          }
        } else if (tok.status === "finished") {
          const coord = path[path.length - 1];
          let baseDest = cellToPixel(coord[0], coord[1]);
          const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
          baseDest.x += offX;
          baseDest.y += offY;
          dest = baseDest;
        }
        dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
        Animated.timing(a, {
          toValue: { x: dest.x, y: dest.y },
          duration: 240,
          useNativeDriver: true,
        }).start();
      });
    });
  }, [tokens, paths, activePlayers, numPlayers]);
  // Stacking animation (shared)
  useEffect(() => {
    if (numPlayers === null) return;
    //@ts-ignore
    activePlayers.forEach((color) => {
      //@ts-ignore
      const path = paths[color] || PATHS[color] || [];
      //@ts-ignore
      (tokens[color] || []).forEach((tok) => {
        //@ts-ignore
        const a = anims[color] && anims[color][tok.id];
        if (!a) return;
        let dest: PixelPosition = { x: 0, y: 0 };
        if (tok.status === "onpath" || tok.status === "returning") {
          if (tok.pathIndex >= 0 && tok.pathIndex < path.length) {
            dest = getStackedPosition(color, tok);
          } else {
            dest = homePixelFor(color, tok.id);
            dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
          }
        } else if (tok.status === "home") {
          dest = homePixelFor(color, tok.id);
          dest = { x: dest.x + TOKEN_OFFSET, y: dest.y + TOKEN_OFFSET };
        } else if (tok.status === "finished") {
          const coord = path[path.length - 1];
          let baseDest = cellToPixel(coord[0], coord[1]);
          const { offX, offY } = getFinishedOffset(tokens, color, tok.id);
          baseDest.x += offX;
          baseDest.y += offY;
          dest = { x: baseDest.x + TOKEN_OFFSET, y: baseDest.y + TOKEN_OFFSET };
        }
        Animated.timing(a, {
          toValue: { x: dest.x, y: dest.y },
          duration: 240,
          useNativeDriver: true,
        }).start();
      });
    });
  }, [tokens, paths, activePlayers, currentPlayerIndex, numPlayers]);
  // Shared helper functions
  const getLegalMoves = useCallback(
    (color: PlayerColor, diceVal: number) => {
      const path = paths[color] || PATHS[color] || [];
      const myTokens = tokens[color] || [];
      const moves: { tokenId: number; action: "bringOut" | "move" }[] = [];
      const homeTurnCoord = HOME_TURN_COORDS[color];
      const homeTurnIndex = path.findIndex(
        (coord) =>
          coord[0] === homeTurnCoord[0] && coord[1] === homeTurnCoord[1]
      );
      myTokens.forEach((t) => {
        if (t.status === "home") {
          if (diceVal === 6) moves.push({ tokenId: t.id, action: "bringOut" });
        } else if (t.status === "onpath") {
          const remaining = path.length - 1 - t.pathIndex;
          const isInHomeStretch =
            homeTurnIndex !== -1 && t.pathIndex >= homeTurnIndex;
          if (isInHomeStretch) {
            if (diceVal <= remaining) {
              moves.push({ tokenId: t.id, action: "move" });
            }
          } else {
            if (remaining > 0) {
              moves.push({ tokenId: t.id, action: "move" });
            }
          }
        }
      });
      return moves;
    },
    [paths, tokens]
  );
  const getTokensAtCell = (row: number, col: number): TokenWithColor[] => {
    const tokensAtCell: TokenWithColor[] = [];
    //@ts-ignore
    activePlayers.forEach((color) => {
      //@ts-ignore
      const path = paths[color] || PATHS[color] || [];
      //@ts-ignore
      (tokens[color] || []).forEach((token) => {
        if (token.status === "onpath" || token.status === "returning") {
          if (token.pathIndex >= 0 && token.pathIndex < path.length) {
            const coord = path[token.pathIndex];
            if (coord && coord[0] === row && coord[1] === col) {
              tokensAtCell.push({ color, token });
            }
          }
        }
      });
    });
    return tokensAtCell;
  };
  const getStackedPosition = (
    color: PlayerColor,
    token: Token
  ): PixelPosition => {
    const path = paths[color] || PATHS[color] || [];
    if (
      (token.status !== "onpath" && token.status !== "returning") ||
      token.pathIndex < 0 ||
      !path[token.pathIndex]
    ) {
      return { x: 0, y: 0 };
    }
    const coord = path[token.pathIndex];
    const tokensAtCell = getTokensAtCell(coord[0], coord[1]);
    tokensAtCell.sort((a, b) => {
      if (a.color === currentColor && b.color !== currentColor) return 1;
      if (a.color !== currentColor && b.color === currentColor) return -1;
      if (a.color === b.color) return a.token.id - b.token.id;
      return activePlayers.indexOf(a.color) - activePlayers.indexOf(b.color);
    });
    const tokenIndex = tokensAtCell.findIndex(
      (t) => t.color === color && t.token.id === token.id
    );
    const basePos = cellToPixel(coord[0], coord[1]);
    const offset = tokenIndex * STACK_OFFSET;
    return {
      x: basePos.x + TOKEN_OFFSET + offset,
      y: basePos.y + TOKEN_OFFSET + offset,
    };
  };
  const getTokenZIndex = (color: PlayerColor, token: Token): number => {
    if (token.status !== "onpath" && token.status !== "returning") {
      if (token.status === "finished") {
        const finishedTokens = (tokens[color] || [])
          .filter((t) => t.status === "finished")
          .sort((a, b) => a.id - b.id);
        const tokenIndex = finishedTokens.findIndex((t) => t.id === token.id);
        return 10 + (tokenIndex + 1);
      }
      return 10;
    }
    const path = paths[color] || PATHS[color] || [];
    if (token.pathIndex < 0 || !path[token.pathIndex]) return 10;
    const coord = path[token.pathIndex];
    const tokensAtCell = getTokensAtCell(coord[0], coord[1]);
    tokensAtCell.sort((a, b) => {
      if (a.color === currentColor && b.color !== currentColor) return 1;
      if (a.color !== currentColor && b.color === currentColor) return -1;
      if (a.color === b.color) return a.token.id - b.token.id;
      return activePlayers.indexOf(a.color) - activePlayers.indexOf(b.color);
    });
    const tokenIndex = tokensAtCell.findIndex(
      (t) => t.color === color && t.token.id === token.id
    );
    return 10 + tokenIndex;
  };
  const renderTokensPile = () => (
    <View style={styles.tokensGrid}>
      {[0, 1, 2, 3].map((i) => (
        <View key={i}>
          <View />
        </View>
      ))}
    </View>
  );
  const getDiceImage = (num: any) => {
    switch (num) {
      case 1:
        return AppIcons.Dice_1;
      case 2:
        return AppIcons.Dice_2;
      case 3:
        return AppIcons.Dice_3;
      case 4:
        return AppIcons.Dice_4;
      case 5:
        return AppIcons.Dice_5;
      case 6:
        return AppIcons.Dice_6;
      default:
        return AppIcons.Dice_1;
    }
  };
  const getDiceButtonStyle = () => {
    const size = CELL_SIZE * 1.2;
    const margin = isTablet ? 45 : 20;
    switch (currentColor) {
      case "red":
        return { top: -size - margin, left: 5 };
      case "blue":
        return { top: -size - margin, right: 5 };
      case "green":
        return { bottom: -size - margin, left: 5 };
      case "yellow":
        return { bottom: -size - margin, right: 5 };
      default:
        return { top: -size - margin, left: 5 };
    }
  };
  const isTurnForDice = isOnline
    ? isMyTurn && !gameOver
    : playingPlayers.length > 0 &&
      !gameOver &&
      playingPlayers.includes(currentColor);

  /**
   * Render a single cell with optional color
   */
  const renderCell = (color?: string, isColorPath: boolean = false) => (
    <View style={styles.cell} />
  );
  return (
    <ImageBackground source={AppIcons.BoardBackground} style={styles.mainView}>
      <TouchableOpacity
        style={styles.backButton}
        activeOpacity={0.7}
        onPress={handleLeaveGame}
      >
        <Image
          source={AppIcons.BackIcon}
          resizeMode="contain"
          style={styles.backIcon}
        />
      </TouchableOpacity>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <View style={styles.rowView}>
          {/* red token and dice */}
          <View>
            <View style={styles.tokenView}>
              <FastImage
                // source={AppIcons.OnlineUser}
                source={
                  redColorUser()?.image
                    ? { uri: redColorUser()?.image }
                    : AppIcons.OnlineUser
                }
                style={styles.tokenBack}
              />
              {currentColor == "red" && (
                <FastImage
                  source={AppIcons.DiceBackground}
                  style={styles.diceBack}
                >
                  <View style={styles.diceview}>
                    <TouchableOpacity
                      onPress={canRoll ? onRoll : undefined}
                      style={[styles.diceview1]}
                      disabled={!canRoll && !isMyTurn}
                    >
                      {isAnimatingDice ? (
                        <LottieView
                          ref={lottieRef}
                          source={require("../../../src/assets/lottie/dice.json")}
                          loop={true}
                          style={[
                            styles.lottieDice,
                            { opacity: isAnimatingDice ? 1 : 0 },
                          ]}
                          speed={1}
                        />
                      ) : dice !== null ? (
                        <Image
                          source={getDiceImage(dice)}
                          style={{
                            width: isTablet ? 60 : 45,
                            height: isTablet ? 60 : 45,
                          }}
                        />
                      ) : (
                        <Image source={AppIcons.Dice} style={styles.dice} resizeMode="contain" />
                      )}
                    </TouchableOpacity>
                  </View>
                </FastImage>
              )}
            </View>
            <Text style={styles.name}>
              {redColorUser()?.name == userData?.name
                ? "You"
                : redColorUser()?.name}
            </Text>
          </View>
          {/* blue token and dice */}
          {connectedPlayersInit?.length > 2 ? (
            <View>
              <View style={[styles.tokenView, { justifyContent: "flex-end" }]}>
                {currentColor == "blue" && (
                  <FastImage
                    source={AppIcons.DiceBackground1}
                    style={styles.diceBack}
                  >
                    <View style={[styles.diceview]}>
                      <TouchableOpacity
                        onPress={canRoll ? onRoll : undefined}
                        style={[
                          styles.diceview1,
                          {
                            marginRight: 25,
                          },
                        ]}
                        disabled={!canRoll && !isMyTurn}
                      >
                        {isAnimatingDice ? (
                          <LottieView
                            ref={lottieRef}
                            source={require("../../../src/assets/lottie/dice.json")}
                            loop={true}
                            style={[
                              styles.lottieDice,
                              { opacity: isAnimatingDice ? 1 : 0 },
                            ]}
                            speed={1}
                          />
                        ) : dice !== null ? (
                          <Image
                            source={getDiceImage(dice)}
                            style={{
                              width: isTablet ? 60 : 45,
                              height: isTablet ? 60 : 45,
                            }}
                          />
                        ) : (
                          <Image source={AppIcons.Dice} style={styles.dice} resizeMode="contain" />
                        )}
                      </TouchableOpacity>
                    </View>
                  </FastImage>
                )}
                <FastImage
                  // source={AppIcons.OnlineUser}
                  source={
                    blueColorUser()?.image
                      ? { uri: blueColorUser()?.image }
                      : AppIcons.OnlineUser
                  }
                  style={styles.tokenBack}
                />
              </View>
              <Text style={[styles.name, { alignSelf: "flex-end" }]}>
                {blueColorUser()?.name == userData?.name
                  ? "You"
                  : blueColorUser()?.name}
              </Text>
            </View>
          ) : (
            <Spacer row />
          )}
        </View>
        <View style={styles.innerContainer}>
          {/* Game Board Container */}
          <View style={styles.boardContainer}>
            <View style={styles.board}>
              {/* Render 15x15 grid of cells */}
              {Array.from({ length: GRID_SIZE }).map((_, row) => (
                <View key={row} style={styles.row}>
                  {Array.from({ length: GRID_SIZE }).map((_, col) => {
                    return <View key={`${row}-${col}`}>{renderCell()}</View>;
                  })}
                </View>
              ))}
              <FastImage
                source={isTablet ? AppIcons.LudoBoard : AppIcons.LudoBoard}
                style={styles.boardImg}
              />
              {activePlayers.includes("red") && (
                <View style={[styles.tokenArea, { top: 0, left: 0 }]}>
                  {allFinishedByColor.red && firstWinner === "red" ? (
                    <Image
                      source={AppIcons.KingIcon}
                      style={styles.crown}
                      resizeMode="contain"
                    />
                  ) : (
                    renderTokensPile()
                  )}
                </View>
              )}
              {activePlayers.includes("blue") && (
                <View style={[styles.tokenArea, { top: 0, right: 0 }]}>
                  {allFinishedByColor.blue && firstWinner === "blue" ? (
                    <Image
                      source={AppIcons.KingIcon}
                      style={styles.crown}
                      resizeMode="contain"
                    />
                  ) : (
                    renderTokensPile()
                  )}
                </View>
              )}
              {activePlayers.includes("green") && (
                <View style={[styles.tokenArea, { bottom: 0, left: 0 }]}>
                  {allFinishedByColor.green && firstWinner === "green" ? (
                    <Image
                      source={AppIcons.KingIcon}
                      style={styles.crown}
                      resizeMode="contain"
                    />
                  ) : (
                    renderTokensPile()
                  )}
                </View>
              )}
              {activePlayers.includes("yellow") && (
                <View style={[styles.tokenArea, { bottom: 0, right: 0 }]}>
                  {allFinishedByColor.yellow && firstWinner === "yellow" ? (
                    <Image
                      source={AppIcons.KingIcon}
                      style={styles.crown}
                      resizeMode="contain"
                    />
                  ) : (
                    renderTokensPile()
                  )}
                </View>
              )}
              {activePlayers.map((color: any) => {
                // @ts-ignore
                return (tokens[color] || []).map((token) => {
                  // @ts-ignore
                  const anim = anims[color] && anims[color][token.id];
                  if (!anim) return null;
                  const zIndex = getTokenZIndex(color, token);
                  return (
                    <TouchableWithoutFeedback
                      key={`${color}-${token.id}`}
                      onPress={() => {
                        setCanTap(false);
                        setTimeout(() => setCanTap(true), 2000);
                        onTokenPress(color, token.id);
                      }}
                      disabled={!canTap || !isTurnForDice}
                    >
                      <Animated.View
                        style={[
                          styles.liveToken,
                          {
                            zIndex,
                            transform: [
                              { translateX: anim.x },
                              { translateY: anim.y },
                            ],
                          },
                        ]}
                      >
                        <Image
                          // @ts-ignore
                          source={PISES_IMAGES[color]}
                          style={styles.tokenImage}
                          resizeMode="contain"
                        />
                      </Animated.View>
                    </TouchableWithoutFeedback>
                  );
                });
              })}
            </View>
          </View>
        </View>
        <Spacer size={8} />
        <View style={styles.rowView}>
          {/* green token and dice */}
          {connectedPlayersInit?.length > 3 ? (
            <View>
              <View style={styles.tokenView}>
                <FastImage
                  // source={AppIcons.OnlineUser}
                  source={
                    greenColorUser()?.image
                      ? { uri: greenColorUser()?.image }
                      : AppIcons.OnlineUser
                  }
                  style={styles.tokenBack}
                />
                {currentColor == "green" && (
                  <FastImage
                    source={AppIcons.DiceBackground}
                    style={styles.diceBack}
                  >
                    <View style={styles.diceview}>
                      <TouchableOpacity
                        onPress={canRoll ? onRoll : undefined}
                        style={[styles.diceview1]}
                        disabled={!canRoll && !isMyTurn}
                      >
                        {isAnimatingDice ? (
                          <LottieView
                            ref={lottieRef}
                            source={require("../../../src/assets/lottie/dice.json")}
                            loop={true}
                            style={[
                              styles.lottieDice,
                              { opacity: isAnimatingDice ? 1 : 0 },
                            ]}
                            speed={1}
                          />
                        ) : dice !== null ? (
                          <Image
                            source={getDiceImage(dice)}
                            style={{
                              width: isTablet ? 60 : 45,
                              height: isTablet ? 60 : 45,
                            }}
                          />
                        ) : (
                          <Image source={AppIcons.Dice} style={styles.dice} resizeMode="contain" />
                        )}
                      </TouchableOpacity>
                    </View>
                  </FastImage>
                )}
              </View>
              <Text style={styles.name}>
                {greenColorUser()?.name == userData?.name
                  ? "You"
                  : greenColorUser()?.name}
              </Text>
            </View>
          ) : (
            <Spacer row />
          )}
          {/* yellow token and dice */}
          <View>
            <View style={[styles.tokenView, { justifyContent: "flex-end" }]}>
              {currentColor == "yellow" && (
                <FastImage
                  source={AppIcons.DiceBackground1}
                  style={styles.diceBack}
                >
                  <View style={[styles.diceview]}>
                    <TouchableOpacity
                      onPress={canRoll ? onRoll : undefined}
                      style={[
                        styles.diceview1,
                        {
                          marginRight: 25,
                        },
                      ]}
                      disabled={!canRoll && !isMyTurn}
                    >
                      {isAnimatingDice ? (
                        <LottieView
                          ref={lottieRef}
                          source={require("../../../src/assets/lottie/dice.json")}
                          loop={true}
                          style={[
                            styles.lottieDice,
                            { opacity: isAnimatingDice ? 1 : 0 },
                          ]}
                          speed={1}
                        />
                      ) : dice !== null ? (
                        <Image
                          source={getDiceImage(dice)}
                          style={{
                            width: isTablet ? 60 : 45,
                            height: isTablet ? 60 : 45,
                          }}
                        />
                      ) : (
                        <Image source={AppIcons.Dice} style={styles.dice} resizeMode="contain" />
                      )}
                    </TouchableOpacity>
                  </View>
                </FastImage>
              )}
              <FastImage
                // source={AppIcons.OnlineUser}
                source={
                  yellowColorUser()?.image
                    ? { uri: yellowColorUser()?.image }
                    : AppIcons.OnlineUser
                }
                style={styles.tokenBack}
              />
            </View>
            <Text style={[styles.name, { alignSelf: "flex-end" }]}>
              {yellowColorUser()?.name == userData?.name
                ? "You"
                : yellowColorUser()?.name}
            </Text>
          </View>
        </View>
        {displayWinners.length > 0 && gameOver && (
          <LottieView
            source={require("../../../src/assets/lottie/boom.json")}
            autoPlay={true}
            loop={true} // Loop until timer ends
            style={styles.lottieAnimation}
          />
        )}
        <View style={styles.botttomView}>
          <BannerAd
            ref={bannerRef}
            unitId={bannerAdKey}
            size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
          />
        </View>
      </View>
      <GameOverModal
        visible={gameOver}
        winners={displayWinners}
        onRestart={() => {
          setGameOver(false);
          setTimeout(() => {
            restartGame();
          }, 100);
        }}
        onClose={() => {
          setGameOver(false);
          setTimeout(() => {
            restartGame();
          }, 100);
        }}
        isOnline={true}
        onlinePlayers={connectedPlayersInit}
      />
      <VoiceComponent
        players={connectedPlayers}
        myColor={myColor}
        isMuted={isMuted}
        onToggleMute={handleToggleMute}
        playerMuteStates={playerMuteStates}
        remoteStreams={remoteStreams}
      />
    </ImageBackground>
  );
};

export default OnlinePlay;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
    backgroundColor: AppTheme.colors.boardBack,
  },
  backButton: {
    position: "absolute",
    top: 70,
    right: 0,
    width: 50,
    height: 40,
    zIndex: 10,
  },
  backIcon: {
    width: 50,
    height: 40,
  },
  innerContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  boardContainer: {
    position: "relative", // For absolute positioning of dice button
  },
  board: {
    width: BOARD_SIZE,
    height: BOARD_SIZE,
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    width: CELL_SIZE,
    height: CELL_SIZE,
    // borderWidth: 0.5,
  },
  boardImg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: CELL_SIZE * 15,
    height: CELL_SIZE * 15,
  },
  rowView: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 10,
  },
  tokenBack: {
    width: 70,
    height: 70,
    paddingLeft: 18,
    paddingTop: 10,
    borderRadius: 10,
  },
  token: {
    width: 25,
    height: 45,
  },
  tokenView: {
    flexDirection: "row",
    alignItems: "center",
  },
  diceBack: {
    width: 72,
    height: 60,
    marginBottom: 7,
    marginHorizontal: 7,
  },
  dice: {
    width: 46,
    height: 46,
  },
  diceview: {
    width: "83%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-end",
  },
  name: {
    fontSize: 18,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    marginBottom: 7,
  },
  diceview1: {
    width: "85%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  tokenArea: {
    position: "absolute",
    width: CELL_SIZE * 6,
    height: CELL_SIZE * 6,
    justifyContent: "center",
    alignItems: "center",
  },
  tokensGrid: {
    width: "70%",
    height: "70%",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignContent: "space-between",
  },
  crown: {
    width: "70%",
    height: "70%",
  },
  floatingDiceButton: {
    position: "absolute",
    zIndex: 1000,
  },
  lottieDice: {
    width: isTablet ? CELL_SIZE * 2.5 : CELL_SIZE * 2.8,
    height: isTablet ? CELL_SIZE * 2.5 : CELL_SIZE * 2.8,
    // marginTop: ,
  },
  controls: {
    marginTop: 20,
    alignItems: "center",
  },
  playerText: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 12,
  },
  buttonRow: {
    flexDirection: "row",
    marginTop: 8,
  },
  lottieAnimation: {
    height: 440,
    // width: 440,
    position: "absolute",
    top: -50,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
  },
  liveToken: {
    position: "absolute",
    width: TOKEN_SIZE,
    height: TOKEN_SIZE,
    borderRadius: TOKEN_SIZE / 2,
    justifyContent: "center",
    alignItems: "center",
  },
  tokenImage: {
    width: isTablet ? 50 : 28, // Scale to fit within token container
    height: isTablet ? 50 : 28,
    marginBottom: 10,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
  centerView: {
    position: "absolute",
    // zIndex: 9999,
    width: CELL_SIZE * 3,
    height: CELL_SIZE * 3,
    top: CELL_SIZE * 6,
    right: CELL_SIZE * 6,
  },
  backBtn: {
    position: "absolute",
    top: 70,
    left: 20,
  },
  backImg: {
    width: 40,
    height: 40,
  },
});
